import { _ as _unsupportedIterableToArray, a as _arrayLikeToArray, i as isErr, e as err, o as ok, b as isOk, c as _createForOfIteratorHelper } from './result-168dfc1d.esm.js';

function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}

function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}

function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}

function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}

function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}

function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}

function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function () {
    return !!t;
  })();
}

function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

function _possibleConstructorReturn(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}

function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}

function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}

function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}

// import { RemoteCompatibleSource, RemoteSource } from "../source/remote";

// import { SerializedI18nSchema } from "./future/i18n";
// import { SerializedOneOfSchema } from "./future/oneOf";

var Schema = /*#__PURE__*/function () {
  function Schema() {
    _classCallCheck(this, Schema);
  }
  return _createClass(Schema, [{
    key: "appendValidationError",
    value:
    // remote(): Src extends RemoteCompatibleSource
    //   ? Schema<RemoteSource<Src>>
    //   : never {
    //   // TODO: Schema<never, "Cannot create remote schema from non-remote source.">
    //   throw new Error("You need Val Ultra to use .remote()");
    // }

    /** MUTATES! since internal and perf sensitive */
    function appendValidationError(current, path, message, value) {
      if (current) {
        if (current[path]) {
          current[path].push({
            message: message,
            value: value
          });
        } else {
          current[path] = [{
            message: message,
            value: value
          }];
        }
        return current;
      } else {
        return _defineProperty({}, path, [{
          message: message,
          value: value
        }]);
      }
    }
  }]);
}();

// TODO: SourceError<"Could not determine type of Schema">

/**
 * @internal
 */
var GetSchema$1 = Symbol("GetSchema");
/**
/**
 * @internal
 */
var Path$1 = Symbol("Path");
/**
 * @internal
 */
var GetSource = Symbol("GetSource");
/**
 * @internal
 */
var ValError = Symbol("ValError");
var GenericSelector = /*#__PURE__*/_createClass(function GenericSelector(valOrExpr, path, schema, error) {
  _classCallCheck(this, GenericSelector);
  this[Path$1] = path;
  this[GetSource] = valOrExpr;
  this[ValError] = error;
  this[GetSchema$1] = schema;
});

/**
 * Use this type to convert types that accepts both Source and Selectors
 *
 * An example would be where literals are supported like in most higher order functions (e.g. map in array)
 **/

function getSchema(selector) {
  return selector[GetSchema$1];
}

/* eslint-disable @typescript-eslint/no-unused-vars */

var Expr = /*#__PURE__*/_createClass(function Expr(span) {
  _classCallCheck(this, Expr);
  this.span = span;
});
var StringLiteral = /*#__PURE__*/function (_Expr) {
  function StringLiteral(value, span) {
    var _this;
    _classCallCheck(this, StringLiteral);
    _this = _callSuper(this, StringLiteral, [span]);
    _defineProperty(_this, "type", "StringLiteral");
    _this.value = value;
    return _this;
  }
  _inherits(StringLiteral, _Expr);
  return _createClass(StringLiteral, [{
    key: "transpile",
    value: function transpile() {
      return "'".concat(this.value, "'");
    }
  }]);
}(Expr);
var Sym = /*#__PURE__*/function (_Expr2) {
  function Sym(value, span) {
    var _this2;
    _classCallCheck(this, Sym);
    _this2 = _callSuper(this, Sym, [span]);
    _defineProperty(_this2, "type", "Sym");
    _this2.value = value;
    return _this2;
  }
  _inherits(Sym, _Expr2);
  return _createClass(Sym, [{
    key: "transpile",
    value: function transpile() {
      return this.value;
    }
  }]);
}(Expr);
var NilSym = new Sym("()");
var StringTemplate = /*#__PURE__*/function (_Expr3) {
  function StringTemplate(children, span) {
    var _this3;
    _classCallCheck(this, StringTemplate);
    _this3 = _callSuper(this, StringTemplate, [span]);
    _defineProperty(_this3, "type", "StringTemplate");
    _this3.children = children;
    return _this3;
  }
  _inherits(StringTemplate, _Expr3);
  return _createClass(StringTemplate, [{
    key: "transpile",
    value: function transpile() {
      return "'".concat(this.children.map(function (child) {
        if (child instanceof StringLiteral) {
          return child.value;
        } else {
          return "${".concat(child.transpile(), "}");
        }
      }).join(""), "'");
    }
  }]);
}(Expr);
var Call = /*#__PURE__*/function (_Expr4) {
  function Call(children, isAnon, span) {
    var _this4;
    _classCallCheck(this, Call);
    _this4 = _callSuper(this, Call, [span]);
    _defineProperty(_this4, "type", "Call");
    _this4.children = children;
    _this4.isAnon = isAnon;
    return _this4;
  }
  _inherits(Call, _Expr4);
  return _createClass(Call, [{
    key: "transpile",
    value: function transpile() {
      if (this.isAnon) {
        return "!(".concat(this.children.map(function (child) {
          return child.transpile();
        }).join(" "), ")");
      }
      return "(".concat(this.children.map(function (child) {
        return child.transpile();
      }).join(" "), ")");
    }
  }]);
}(Expr);

/* Branded extension types: file, remote, i18n  */
var VAL_EXTENSION = "_type";

/**
 * A phantom type parameter is one that doesn't show up at runtime, but is checked statically (and only) at compile time.
 *
 * An example where this is useful is remote types, where the type of the remote source is known at compile time,
 * but the value is not there before it is fetched.
 *
 * @example
 * type Example<T> = string & PhantomType<T>;
 *
 **/

var FILE_REF_PROP = "_ref";
var FILE_REF_SUBTYPE_TAG = "_tag"; // TODO: used earlier by c.rt.image, when we remove c.rt we can remove this

/**
 * A file source represents the path to a (local) file.
 *
 * It will be resolved into a Asset object.
 *
 */

var initFile = function initFile(config) {
  var _config$files$directo, _config$files;
  (_config$files$directo = config === null || config === void 0 || (_config$files = config.files) === null || _config$files === void 0 ? void 0 : _config$files.directory) !== null && _config$files$directo !== void 0 ? _config$files$directo : "/public/val";
  function file(ref, metadata) {
    return _defineProperty(_defineProperty(_defineProperty({}, FILE_REF_PROP, ref), VAL_EXTENSION, "file"), "metadata", metadata);
  }
  return file;
};

// type Directory =
//   | (typeof config extends { files: { directory: infer D } } ? D : never)
//   | `/public/val`;
// console.log("path", config);
// const userSpecifiedDirectory: Directory = config ?? "/public/val";

// const directory = userSpecifiedDirectory;

// export function file<Metadata extends { readonly [key: string]: Json }>(
//   ref: `${typeof directory}/${string}`,
//   metadata: Metadata
// ): FileSource<Metadata>;
// export function file(
//   ref: `${typeof directory}/${string}`,
//   metadata?: undefined
// ): FileSource<undefined>;
// export function file<
//   Metadata extends { readonly [key: string]: Json } | undefined
// >(
//   ref: `${typeof directory}/${string}`,
//   metadata?: Metadata
// ): FileSource<Metadata> {
//   return {
//     [FILE_REF_PROP]: ref,
//     [VAL_EXTENSION]: "file",
//     metadata,
//   } as FileSource<Metadata>;
// }

function isFile(obj) {
  return _typeof(obj) === "object" && obj !== null && VAL_EXTENSION in obj && obj[VAL_EXTENSION] === "file" && FILE_REF_PROP in obj && typeof obj[FILE_REF_PROP] === "string";
}

var FileSchema = /*#__PURE__*/function (_Schema) {
  function FileSchema(options) {
    var _this;
    var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    _classCallCheck(this, FileSchema);
    _this = _callSuper(this, FileSchema);
    _this.options = options;
    _this.opt = opt;
    return _this;
  }
  _inherits(FileSchema, _Schema);
  return _createClass(FileSchema, [{
    key: "validate",
    value: function validate(path, src) {
      if (this.opt && (src === null || src === undefined)) {
        return false;
      }
      if (src === null || src === undefined) {
        return _defineProperty({}, path, [{
          message: "Non-optional file was null or undefined.",
          value: src
        }]);
      }
      if (typeof src[FILE_REF_PROP] !== "string") {
        return _defineProperty({}, path, [{
          message: "File did not have a file reference string. Got: ".concat(_typeof(src[FILE_REF_PROP])),
          value: src
        }]);
      }
      if (src[VAL_EXTENSION] !== "file") {
        return _defineProperty({}, path, [{
          message: "File did not have the valid file extension type. Got: ".concat(src[VAL_EXTENSION]),
          value: src,
          fixes: ["file:change-extension", "file:check-metadata"]
        }]);
      }
      var _ref4 = this.options || {},
        accept = _ref4.accept;
      var _ref5 = src.metadata || {},
        mimeType = _ref5.mimeType;
      if (accept && mimeType && !mimeType.includes("/")) {
        return _defineProperty({}, path, [{
          message: "Invalid mime type format. Got: ".concat(mimeType),
          value: src,
          fixes: ["file:change-extension", "file:check-metadata"]
        }]);
      }
      if (accept && mimeType && mimeType.includes("/")) {
        var acceptedTypes = accept.split(",").map(function (type) {
          return type.trim();
        });
        var isValidMimeType = acceptedTypes.some(function (acceptedType) {
          if (acceptedType === "*/*") {
            return true;
          }
          if (acceptedType.endsWith("/*")) {
            var baseType = acceptedType.slice(0, -2);
            return mimeType.startsWith(baseType);
          }
          return acceptedType === mimeType;
        });
        if (!isValidMimeType) {
          return _defineProperty({}, path, [{
            message: "Mime type mismatch. Found '".concat(mimeType, "' but schema accepts '").concat(accept, "'"),
            value: src,
            fixes: ["file:change-extension", "file:check-metadata"]
          }]);
        }
      }
      var fileMimeType = Internal.filenameToMimeType(src[FILE_REF_PROP]);
      if (!fileMimeType) {
        return _defineProperty({}, path, [{
          message: "Could not determine mime type from file extension. Got: ".concat(src[FILE_REF_PROP]),
          value: src,
          fixes: ["file:change-extension", "file:check-metadata"]
        }]);
      }
      if (fileMimeType !== mimeType) {
        return _defineProperty({}, path, [{
          message: "Mime type and file extension not matching. Mime type is '".concat(mimeType, "' but file extension is '").concat(fileMimeType, "'"),
          value: src,
          fixes: ["file:change-extension", "file:check-metadata"]
        }]);
      }
      if (src.metadata) {
        return _defineProperty({}, path, [{
          message: "Found metadata, but it could not be validated. File metadata must be an object with the mimeType.",
          // These validation errors will have to be picked up by logic outside of this package and revalidated. Reasons: 1) we have to read files to verify the metadata, which is handled differently in different runtimes (Browser, QuickJS, Node.js); 2) we want to keep this package dependency free.
          value: src,
          fixes: ["file:check-metadata"]
        }]);
      }
      return _defineProperty({}, path, [{
        message: "Missing File metadata.",
        value: src,
        fixes: ["file:add-metadata"]
      }]);
    }
  }, {
    key: "assert",
    value: function assert(path, src) {
      if (this.opt && src === null) {
        return {
          success: true,
          data: src
        };
      }
      if (src === null) {
        return {
          success: false,
          errors: _defineProperty({}, path, [{
            message: "Expected 'object', got 'null'",
            typeError: true
          }])
        };
      }
      if (_typeof(src) !== "object") {
        return {
          success: false,
          errors: _defineProperty({}, path, [{
            message: "Expected object, got '".concat(_typeof(src), "'"),
            typeError: true
          }])
        };
      }
      if (!(FILE_REF_PROP in src)) {
        return {
          success: false,
          errors: _defineProperty({}, path, [{
            message: "Value of this schema must use: 'c.file' (error type: missing_ref_prop)",
            typeError: true
          }])
        };
      }
      if (!(VAL_EXTENSION in src && src[VAL_EXTENSION] === "file")) {
        return {
          success: false,
          errors: _defineProperty({}, path, [{
            message: "Value of this schema must use: 'c.file' (error type: missing_file_extension)",
            typeError: true
          }])
        };
      }
      return {
        success: true,
        data: src
      };
    }
  }, {
    key: "nullable",
    value: function nullable() {
      return new FileSchema(this.options, true);
    }
  }, {
    key: "serialize",
    value: function serialize() {
      return {
        type: "file",
        options: this.options,
        opt: this.opt
      };
    }
  }]);
}(Schema);
var file = function file(options) {
  return new FileSchema(options);
};
function convertFileSource(src) {
  // TODO: /public should be configurable
  if (!src[FILE_REF_PROP].startsWith("/public")) {
    return {
      url: src[FILE_REF_PROP] + (src.patch_id ? "?patch_id=".concat(src["patch_id"]) : ""),
      metadata: src.metadata
    };
  }
  if (src.patch_id) {
    return {
      url: "/api/val/files" + src[FILE_REF_PROP] + "?patch_id=".concat(src["patch_id"]),
      metadata: src.metadata
    };
  }
  return {
    url: src[FILE_REF_PROP].slice("/public".length),
    metadata: src.metadata
  };
}

function isSerializedVal(val) {
  return _typeof(val) === "object" && val !== null && val !== undefined && ("val" in val || "valPath" in val);
}
function isVal(val) {
  return _typeof(val) === "object" && val !== null && val !== undefined && Path$1 in val && "val" in val;
}

/**
 * The path of the source value.
 *
 * @example
 * '/app/blogs.val.ts?p=0.text' // the text property of the first element of the /app/blogs module
 */

/**
 * The path inside the module.
 *
 * @example
 * '0."text"' // the text property of the first element of the module
 */

/**
 * The path of the module.
 *
 * @example
 * '/app/blogs.val.ts'
 */

/**
 * The patchId of the parent patch, or "head" if there is no parent patch.
 */

function getValPath(valOrSelector) {
  return valOrSelector[Path$1];
}

function hasOwn$2(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}
function _andThen$1(f, source, path) {
  if (source) {
    return newSelectorProxy$1(f(newSelectorProxy$1(source, path)));
  }
  return newSelectorProxy$1(source, path);
}
function isSelector$1(source) {
  return _typeof(source) === "object" && source !== null && (GetSource in source || Path$1 in source);
}
function newSelectorProxy$1(source, path, moduleSchema) {
  if (_typeof(source) === "object") {
    if (isSelector$1(source)) {
      return source;
    } else if (isSerializedVal(source)) {
      return newSelectorProxy$1(source.val, source.valPath);
    }
  }
  if (source && source[FILE_REF_PROP] && source[VAL_EXTENSION] === "file") {
    var fileRef = source[FILE_REF_PROP];
    if (typeof fileRef !== "string") {
      throw Error("Invalid file ref: " + fileRef);
    }
    return newSelectorProxy$1(convertFileSource(source), path, moduleSchema);
  }
  switch (_typeof(source)) {
    case "function":
    case "symbol":
      throw Error("Invalid selector type: ".concat(_typeof(source), ": ").concat(source));
    case "object":
      // Handles both objects and arrays!
      if (source !== null) {
        return new Proxy(source, {
          // TODO: see proxy docs if we want more traps
          has: function has(target, prop) {
            if (prop === GetSource) {
              return true;
            }
            if (prop === Path$1) {
              return true;
            }
            if (prop === "andThen") {
              return true;
            }
            if (prop === GetSchema$1) {
              return true;
            }
            return prop in target;
          },
          get: function get(target, prop) {
            if (prop === GetSource) {
              return source;
            }
            if (prop === Path$1) {
              return path;
            }
            if (prop === GetSchema$1) {
              return moduleSchema;
            }
            if (prop === "andThen") {
              return function (f) {
                return _andThen$1(f, source, path);
              };
            }
            if (Array.isArray(target)) {
              if (prop === "filter") {
                return function (f) {
                  var filtered = target.map(function (a, i) {
                    return newSelectorProxy$1(a, createValPathOfItem(path, i), moduleSchema === null || moduleSchema === void 0 ? void 0 : moduleSchema.item);
                  }).filter(function (a) {
                    if (f && f instanceof Schema) {
                      return f.assert(path || "", unValify$1(a)).success;
                    } else {
                      return unValify$1(f(a));
                    }
                  });
                  return newSelectorProxy$1(filtered, path, moduleSchema);
                };
              } else if (prop === "map") {
                return function (f) {
                  var filtered = target.map(function (a, i) {
                    var valueOrSelector = f(newSelectorProxy$1(a, createValPathOfItem(path, i), moduleSchema === null || moduleSchema === void 0 ? void 0 : moduleSchema.item), newSelectorProxy$1(i));
                    if (isSelector$1(valueOrSelector)) {
                      return valueOrSelector;
                    }
                    return newSelectorProxy$1(valueOrSelector);
                  });
                  return newSelectorProxy$1(filtered, path, moduleSchema);
                };
              }
            }
            if (Array.isArray(target) && prop === "length") {
              return newSelectorProxy$1(target.length);
            }
            var reflectedValue = Reflect.get(target, prop);
            if (hasOwn$2(source, prop)) {
              if (!Number.isNaN(Number(prop))) {
                return newSelectorProxy$1(reflectedValue, createValPathOfItem(path, Number(prop)), moduleSchema === null || moduleSchema === void 0 ? void 0 : moduleSchema.item);
              }
              return newSelectorProxy$1(reflectedValue, createValPathOfItem(path, prop), moduleSchema === null || moduleSchema === void 0 ? void 0 : moduleSchema.items[prop]);
            }
            return reflectedValue;
          }
        });
      }
    // intentional fallthrough
    // eslint-disable-next-line no-fallthrough
    default:
      return _defineProperty(_defineProperty(_defineProperty({
        eq: function eq(other) {
          var otherValue = other;
          if (isSelector$1(other)) {
            otherValue = other[GetSource];
            if (otherValue instanceof Expr) {
              throw Error("TODO: Cannot evaluate equality with an Expr");
            }
          }
          return newSelectorProxy$1(source === otherValue, undefined);
        },
        andThen: function andThen(f) {
          return _andThen$1(f, source === undefined ? null : source, path);
        }
      }, GetSource, source === undefined ? null : source), Path$1, path), GetSchema$1, moduleSchema);
  }
}
function createValPathOfItem(arrayPath, prop) {
  if (_typeof(prop) === "symbol") {
    throw Error("Cannot create val path of array item with symbol prop: ".concat(prop.toString()));
  }
  if (!arrayPath) {
    return undefined;
  }
  if (arrayPath.includes(Internal.ModuleFilePathSep)) {
    return "".concat(arrayPath, ".").concat(JSON.stringify(prop));
  }
  return "".concat(arrayPath).concat(Internal.ModuleFilePathSep).concat(JSON.stringify(prop));
}

// TODO: replace createValPathOfItem everywhere with this newer implementation (that does not return undefined but throws)
function unsafeCreateSourcePath(path, itemKey) {
  if (_typeof(itemKey) === "symbol") {
    throw Error("Cannot create val path of array item with symbol prop: ".concat(itemKey.toString()));
  }
  if (!path) {
    throw Error("Cannot create val path of array item of empty or missing path: ".concat(path, ". Item: ").concat(itemKey));
  }
  if (path.includes(Internal.ModuleFilePathSep)) {
    return "".concat(path, ".").concat(JSON.stringify(itemKey));
  }
  return "".concat(path).concat(Internal.ModuleFilePathSep).concat(JSON.stringify(itemKey));
}

// TODO: could we do .val on the objects instead?
function unValify$1(valueOrSelector) {
  if (_typeof(valueOrSelector) === "object" && (GetSource in valueOrSelector || Path$1 in valueOrSelector)) {
    var selectorValue = valueOrSelector[GetSource];
    return selectorValue;
  }
  return valueOrSelector;
}

var ObjectSchema = /*#__PURE__*/function (_Schema) {
  function ObjectSchema(items) {
    var _this;
    var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    _classCallCheck(this, ObjectSchema);
    _this = _callSuper(this, ObjectSchema);
    _this.items = items;
    _this.opt = opt;
    return _this;
  }
  _inherits(ObjectSchema, _Schema);
  return _createClass(ObjectSchema, [{
    key: "validate",
    value: function validate(path, src) {
      var _this2 = this;
      var error = false;

      // TODO: src should never be undefined
      if (this.opt && (src === null || src === undefined)) {
        return false;
      }
      if (src === null) {
        return _defineProperty({}, path, [{
          message: "Expected 'object', got 'null'"
        }]);
      }
      if (_typeof(src) !== "object") {
        return _defineProperty({}, path, [{
          message: "Expected 'object', got '".concat(_typeof(src), "'")
        }]);
      } else if (Array.isArray(src)) {
        return _defineProperty({}, path, [{
          message: "Expected 'object', got 'array'"
        }]);
      }
      Object.entries(this.items).forEach(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
          key = _ref5[0],
          schema = _ref5[1];
        var subPath = createValPathOfItem(path, key);
        if (!subPath) {
          error = _this2.appendValidationError(error, path, "Internal error: could not create path at ".concat(!path && typeof path === "string" ? "<empty string>" : path, " at key ").concat(key),
          // Should! never happen
          src);
        } else {
          var subError = schema.validate(subPath, src[key]);
          if (subError && error) {
            error = _objectSpread2(_objectSpread2({}, subError), error);
          } else if (subError) {
            error = subError;
          }
        }
      });
      return error;
    }
  }, {
    key: "assert",
    value: function assert(path, src) {
      if (this.opt && src === null) {
        return {
          success: true,
          data: src
        };
      }
      if (src === null) {
        return {
          success: false,
          errors: _defineProperty({}, path, [{
            message: "Expected 'object', got 'null'",
            typeError: true
          }])
        };
      }
      if (_typeof(src) !== "object") {
        return {
          success: false,
          errors: _defineProperty({}, path, [{
            message: "Expected 'object', got '".concat(_typeof(src), "'"),
            typeError: true
          }])
        };
      } else if (Array.isArray(src)) {
        return {
          success: false,
          errors: _defineProperty({}, path, [{
            message: "Expected 'object', got 'array'",
            typeError: true
          }])
        };
      }
      var errorsAtPath = [];
      for (var _i = 0, _Object$keys = Object.keys(this.items); _i < _Object$keys.length; _i++) {
        var _key = _Object$keys[_i];
        var subPath = createValPathOfItem(path, _key);
        if (!subPath) {
          errorsAtPath.push({
            message: "Internal error: could not create path at ".concat(!path && typeof path === "string" ? "<empty string>" : path, " at key ").concat(_key),
            // Should! never happen
            internalError: true
          });
        } else if (!(_key in src)) {
          errorsAtPath.push({
            message: "Expected key '".concat(_key, "' not found in object"),
            typeError: true
          });
        }
      }
      if (errorsAtPath.length > 0) {
        return {
          success: false,
          errors: _defineProperty({}, path, errorsAtPath)
        };
      }
      return {
        success: true,
        data: src
      };
    }
  }, {
    key: "nullable",
    value: function nullable() {
      return new ObjectSchema(this.items, true);
    }
  }, {
    key: "serialize",
    value: function serialize() {
      return {
        type: "object",
        items: Object.fromEntries(Object.entries(this.items).map(function (_ref6) {
          var _ref7 = _slicedToArray(_ref6, 2),
            key = _ref7[0],
            schema = _ref7[1];
          return [key, schema.serialize()];
        })),
        opt: this.opt
      };
    }
  }]);
}(Schema);
var object = function object(schema) {
  return new ObjectSchema(schema);
};

var WHITE_SPACE = ["\n", "\r", "\t", " "];
function tokenize(input) {
  var tokens = [];
  var cursor = 0;
  while (cursor < input.length) {
    var _char = input[cursor];
    var peek = input[cursor + 1];
    // TODO: remove this not used any more
    if (_char === "!" && peek === "(") {
      tokens.push({
        type: "!(",
        span: [cursor, cursor + 1]
      });
      cursor += 2;
    } else if (_char === "(") {
      tokens.push({
        type: "(",
        span: [cursor, cursor]
      });
      cursor++;
    } else if (_char === ")") {
      tokens.push({
        type: ")",
        span: [cursor, cursor]
      });
      cursor++;
    } else if (_char === "'" || _char === "}") {
      var start = cursor;
      var value = "";
      var unescapedValue = "";
      var escaped = false;
      if (_char === "}") {
        tokens.push({
          type: "}",
          span: [cursor, cursor]
        });
      } else if (_char === "'") {
        tokens.push({
          type: "'",
          span: [cursor, cursor]
        });
      }
      while (cursor < input.length) {
        if (_char === "\\") {
          escaped = !escaped;
        } else {
          escaped = false;
        }
        if (peek === "'" && !escaped) {
          cursor += 2;
          break;
        } else if (_char === "$" && peek === "{") {
          cursor += 2;
          break;
        }
        cursor++;
        _char = input[cursor];
        peek = input[cursor + 1];
        if (!(_char === "$" && peek === "{") && cursor < input.length) {
          if (!(_char === "\\" && !escaped // counter-intuitive, but escape just became false if this was a backslash we want to escape
          )) {
            value += _char;
          }
          unescapedValue += _char;
        }
      }
      var cursorOffset = peek === "'" && !escaped ? 2 : _char === "$" && peek === "{" ? 3 : 1;
      if (value) {
        tokens.push(_objectSpread2({
          type: "string",
          span: [start + 1, cursor - cursorOffset],
          value: value
        }, unescapedValue !== value && {
          unescapedValue: unescapedValue
        }));
      }
      if (peek === "'" && !escaped) {
        tokens.push({
          type: "'",
          span: [cursor - 1, cursor - 1]
        });
      } else if (_char === "$" && peek === "{") {
        tokens.push({
          type: "${",
          span: [cursor - cursorOffset + 1, cursor - 1]
        });
      }
    } else if (WHITE_SPACE.includes(_char)) {
      var _start = cursor;
      while (WHITE_SPACE.includes(input[cursor]) && cursor < input.length) {
        cursor++;
      }
      tokens.push({
        type: "ws",
        span: [_start, cursor - 1]
      });
    } else {
      var _value = "";
      var _start2 = cursor;
      do {
        _char = input[cursor];
        peek = input[cursor + 1];
        _value += _char;
        cursor++;
      } while (!WHITE_SPACE.includes(peek) && peek !== ")" && peek !== "'" && cursor < input.length);
      tokens.push({
        type: "token",
        span: [_start2, cursor - 1],
        value: _value
      });
    }
  }
  return [tokens, cursor];
}

var ParserError = /*#__PURE__*/_createClass(function ParserError(message, span) {
  _classCallCheck(this, ParserError);
  this.message = message;
  this.span = span;
});
function parseTokens(inputTokens) {
  var tokens = inputTokens.slice();
  function slurpCall(first, isAnon) {
    var _tokens$, _tokens$2, _tokens$3, _tokens$7, _tokens$8, _args$slice$0$span;
    // peek
    if (((_tokens$ = tokens[0]) === null || _tokens$ === void 0 ? void 0 : _tokens$.type) === "ws" && ((_tokens$2 = tokens[1]) === null || _tokens$2 === void 0 ? void 0 : _tokens$2.type) === ")" || ((_tokens$3 = tokens[0]) === null || _tokens$3 === void 0 ? void 0 : _tokens$3.type) === ")") {
      slurpWs();
      tokens.shift();
      return ok(new Sym("()", [first.span[0], first.span[1] + 1]));
    }
    var args = [];
    var completed = false;
    while (!completed) {
      var _res = slurp();
      if (isOk(_res)) {
        var _tokens$4, _tokens$5, _tokens$6;
        args.push(_res.value);
        completed = ((_tokens$4 = tokens[0]) === null || _tokens$4 === void 0 ? void 0 : _tokens$4.type) !== "ws" || ((_tokens$5 = tokens[0]) === null || _tokens$5 === void 0 ? void 0 : _tokens$5.type) === "ws" && ((_tokens$6 = tokens[1]) === null || _tokens$6 === void 0 ? void 0 : _tokens$6.type) === ")";
      } else {
        return _res;
      }
    }
    if (((_tokens$7 = tokens[0]) === null || _tokens$7 === void 0 ? void 0 : _tokens$7.type) === "ws" && ((_tokens$8 = tokens[1]) === null || _tokens$8 === void 0 ? void 0 : _tokens$8.type) === ")") {
      tokens.shift();
    }
    var last = tokens.shift();
    if ((last === null || last === void 0 ? void 0 : last.type) !== ")") {
      return err(new ParserError("unbalanced parens: missing a ')'", [first.span[0], first.span[1] + 1]));
    }
    return ok(new Call(args, isAnon, [first.span[0], ((_args$slice$0$span = args.slice(-1)[0].span) === null || _args$slice$0$span === void 0 ? void 0 : _args$slice$0$span[1]) || -1]));
  }
  function slurpWs() {
    while (((_tokens$9 = tokens[0]) === null || _tokens$9 === void 0 ? void 0 : _tokens$9.type) === "ws") {
      var _tokens$9;
      tokens.shift();
    }
  }
  function slurpTemplate(first) {
    var children = [];
    while (tokens.length > 0) {
      var _tokens$10;
      if (((_tokens$10 = tokens[0]) === null || _tokens$10 === void 0 ? void 0 : _tokens$10.type) === "'") {
        break;
      }
      var nextToken = tokens.shift();
      if ((nextToken === null || nextToken === void 0 ? void 0 : nextToken.type) === "${") {
        var _res2 = slurp();
        if (isOk(_res2)) {
          children.push(_res2.value);
          var _last = tokens.shift();
          if (!_last) {
            var _children$slice$0$spa;
            return err(new ParserError("unbalanced string template: missing a '}'", [first.span[0], (_children$slice$0$spa = children.slice(-1)[0].span) === null || _children$slice$0$spa === void 0 ? void 0 : _children$slice$0$spa[1]]));
          } else if (_last.type !== "}") {
            return err(new ParserError("unbalanced string template: expected '}'", _last.span));
          }
        } else {
          return _res2;
        }
      } else if ((nextToken === null || nextToken === void 0 ? void 0 : nextToken.type) === "string") {
        children.push(new StringLiteral(nextToken.unescapedValue || nextToken.value || "", nextToken.span));
      }
    }
    var last = tokens.shift();
    if (!last) {
      var _children$slice$0$spa2;
      return err(new ParserError("unbalanced string template: missing a '''", [first.span[0], (_children$slice$0$spa2 = children.slice(-1)[0].span) === null || _children$slice$0$spa2 === void 0 ? void 0 : _children$slice$0$spa2[1]]));
    } else if (last.type !== "'") {
      return err(new ParserError("unbalanced string template: expected '''", last.span));
    }
    return ok(new StringTemplate(children, [first.span[0], last.span[1]]));
  }
  function slurpString(first) {
    var _tokens$11, _tokens$12, _tokens$13;
    if (((_tokens$11 = tokens[0]) === null || _tokens$11 === void 0 ? void 0 : _tokens$11.type) === "string" && ((_tokens$12 = tokens[1]) === null || _tokens$12 === void 0 ? void 0 : _tokens$12.type) === "'") {
      var stringToken = tokens.shift();
      var last = tokens.shift();
      if (!last || !stringToken) {
        throw Error("Unexpected error: stringToken or last is undefined");
      }
      return ok(new StringLiteral(stringToken.unescapedValue || stringToken.value || "", [first.span[0], last.span[1]]));
    } else if (((_tokens$13 = tokens[0]) === null || _tokens$13 === void 0 ? void 0 : _tokens$13.type) === "'") {
      var _last2 = tokens.shift();
      if (!_last2) {
        throw Error("Unexpected error: last is undefined");
      }
      return ok(new StringLiteral("", [first.span[0], _last2.span[1]]));
    } else {
      return slurpTemplate(first);
    }
  }
  function slurp() {
    slurpWs();
    var first = tokens.shift();
    if (!first) {
      return err(new ParserError("expected '(', '!(', string or literal", [0, 0]));
    }
    if (first.type === "(" || first.type === "!(") {
      return slurpCall(first, first.type === "!(");
    } else if (first.type === "'") {
      return slurpString(first);
    } else if (first.type === "token") {
      var _first$value, _first$value2, _first$value3, _first$value4, _first$value5, _first$value6;
      if ((_first$value = first.value) !== null && _first$value !== void 0 && _first$value.includes("(") || (_first$value2 = first.value) !== null && _first$value2 !== void 0 && _first$value2.includes(")")) {
        return err(new ParserError("unexpected token: '(' and ')' are not allowed in tokens", first.span));
      }
      if ((_first$value3 = first.value) !== null && _first$value3 !== void 0 && _first$value3.includes("'")) {
        return err(new ParserError('unexpected token: "\'" is not allowed in tokens', first.span));
      }
      if ((_first$value4 = first.value) !== null && _first$value4 !== void 0 && _first$value4.includes(".")) {
        return err(new ParserError('unexpected token: "." is not allowed in tokens', first.span));
      }
      if ((_first$value5 = first.value) !== null && _first$value5 !== void 0 && _first$value5.includes("{") || (_first$value6 = first.value) !== null && _first$value6 !== void 0 && _first$value6.includes("}")) {
        return err(new ParserError("unexpected token: '{' and '}' are not allowed in tokens", first.span));
      }
      return ok(new Sym(first.value || "", first.span));
    } else {
      return err(new ParserError("expected '(', '!(' or literal or token".concat(first.value || first.type ? ", got: '".concat(first.value || first.type, "'") : ""), first.span));
    }
  }
  var res = slurp();
  slurpWs();
  if (isErr(res)) {
    return res;
  }
  if (tokens.length > 0) {
    return err(new ParserError("expected end of input, superfluous tokens", [tokens[0].span[0], tokens.slice(-1)[0].span[1]]));
  }
  return res;
}
function parse(input) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  var _tokenize = tokenize(input),
    _tokenize2 = _slicedToArray(_tokenize, 2),
    tokens = _tokenize2[0];
    _tokenize2[1]; // TODO: we can use cursor to improve error messages / spans
  return parseTokens(tokens);
}

/* eslint-disable @typescript-eslint/no-unused-vars */

/**
 * Selectors can be used to select parts of a Val module.
 * Unlike queries, joins, aggregates etc is and will not be supported.
 *
 * They are designed to be be used as if they were "normal" JSON data,
 * though some concessions had to be made because of TypeScript limitations.
 *
 * Selectors works equally on source content, defined in code, and remote content.
 *
 * @example
 * // Select the title of a document
 * const titles = useVal(docsVal.map((doc) => doc.title));
 *
 * @example
 * // Match on a union type
 * const titles = useVal(docsVal.map((doc) => doc.fold("type")({
 *   newsletter: (newsletter) => newsletter.title,
 *   email: (email) => email.subject,
 * }));
 *
 */

/**
 * @internal
 */
var GetSchema = Symbol("GetSchema");
/**
/**
 * @internal
 */
var Path = Symbol("Path");
/**
 * @internal
 */
var SourceOrExpr = Symbol("SourceOrExpr");

/**
 * Use this type to convert types that accepts both Source and Selectors
 *
 * An example would be where literals are supported like in most higher order functions (e.g. map in array)
 **/

function hasOwn$1(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}
function _andThen(f, source, path) {
  if (source) {
    return newSelectorProxy(f(newSelectorProxy(source, path)));
  }
  return newSelectorProxy(source, path);
}
function isSelector(source) {
  return _typeof(source) === "object" && source !== null && (SourceOrExpr in source || Path in source);
}
function newSelectorProxy(source, path, moduleSchema) {
  if (_typeof(source) === "object") {
    if (isSelector(source)) {
      return source;
    } else if (isSerializedVal(source)) {
      return newSelectorProxy(source.val, source.valPath);
    }
  }
  if (source && source[FILE_REF_PROP] && source[VAL_EXTENSION] === "file") {
    var fileRef = source[FILE_REF_PROP];
    if (typeof fileRef !== "string") {
      throw Error("Invalid file ref: " + fileRef);
    }
    return newSelectorProxy(convertFileSource(source), path, moduleSchema);
  }
  switch (_typeof(source)) {
    case "function":
    case "symbol":
      throw Error("Invalid selector type: ".concat(_typeof(source), ": ").concat(source));
    case "object":
      // Handles both objects and arrays!
      if (source !== null) {
        return new Proxy(source, {
          // TODO: see proxy docs if we want more traps
          has: function has(target, prop) {
            if (prop === SourceOrExpr) {
              return true;
            }
            if (prop === Path) {
              return true;
            }
            if (prop === "andThen") {
              return true;
            }
            if (prop === GetSchema) {
              return true;
            }
            return prop in target;
          },
          get: function get(target, prop) {
            if (prop === SourceOrExpr) {
              return source;
            }
            if (prop === Path) {
              return path;
            }
            if (prop === GetSchema) {
              return moduleSchema;
            }
            if (prop === "andThen") {
              return function (f) {
                return _andThen(f, source, path);
              };
            }
            if (Array.isArray(target)) {
              if (prop === "filter") {
                return function (f) {
                  var filtered = target.map(function (a, i) {
                    return newSelectorProxy(a, createValPathOfItem(path, i), moduleSchema === null || moduleSchema === void 0 ? void 0 : moduleSchema.item);
                  }).filter(function (a) {
                    if (f && f instanceof Schema) {
                      return f.assert(path || "", unValify(a)).success;
                    } else {
                      return unValify(f(a));
                    }
                  });
                  return newSelectorProxy(filtered, path, moduleSchema);
                };
              } else if (prop === "map") {
                return function (f) {
                  var filtered = target.map(function (a, i) {
                    var valueOrSelector = f(newSelectorProxy(a, createValPathOfItem(path, i), moduleSchema === null || moduleSchema === void 0 ? void 0 : moduleSchema.item), newSelectorProxy(i));
                    if (isSelector(valueOrSelector)) {
                      return valueOrSelector;
                    }
                    return newSelectorProxy(valueOrSelector);
                  });
                  return newSelectorProxy(filtered, path, moduleSchema);
                };
              }
            }
            if (Array.isArray(target) && prop === "length") {
              return newSelectorProxy(target.length);
            }
            var reflectedValue = Reflect.get(target, prop);
            if (hasOwn$1(source, prop)) {
              if (!Number.isNaN(Number(prop))) {
                return newSelectorProxy(reflectedValue, createValPathOfItem(path, Number(prop)), moduleSchema === null || moduleSchema === void 0 ? void 0 : moduleSchema.item);
              }
              return newSelectorProxy(reflectedValue, createValPathOfItem(path, prop), moduleSchema === null || moduleSchema === void 0 ? void 0 : moduleSchema.items[prop]);
            }
            return reflectedValue;
          }
        });
      }
    // intentional fallthrough
    // eslint-disable-next-line no-fallthrough
    default:
      return _defineProperty(_defineProperty(_defineProperty({
        eq: function eq(other) {
          var otherValue = other;
          if (isSelector(other)) {
            otherValue = other[SourceOrExpr];
            if (otherValue instanceof Expr) {
              throw Error("TODO: Cannot evaluate equality with an Expr");
            }
          }
          return newSelectorProxy(source === otherValue, undefined);
        },
        andThen: function andThen(f) {
          return _andThen(f, source === undefined ? null : source, path);
        }
      }, SourceOrExpr, source === undefined ? null : source), Path, path), GetSchema, moduleSchema);
  }
}

// TODO: could we do .val on the objects instead?
function unValify(valueOrSelector) {
  if (_typeof(valueOrSelector) === "object" && (SourceOrExpr in valueOrSelector || Path in valueOrSelector)) {
    var selectorValue = valueOrSelector[SourceOrExpr];
    return selectorValue;
  }
  return valueOrSelector;
}

var EvalError = /*#__PURE__*/function () {
  function EvalError(message, expr) {
    _classCallCheck(this, EvalError);
    this.message = message;
    this.expr = expr;
  }
  return _createClass(EvalError, [{
    key: "toString",
    value: function toString() {
      return "".concat(this.message, " in: ").concat(this.expr.transpile());
    }
  }]);
}();
var MAX_STACK_SIZE = 100; // an arbitrary semi-large number
function evaluateSync(expr, getSource, stack) {
  // TODO: amount of evaluates should be limited?
  if (stack.length > MAX_STACK_SIZE) {
    throw new EvalError("Stack overflow. Final frames: ".concat(stack.slice(-10).map(function (frame, i) {
      return frame.map(function (s, j) {
        return "@[".concat(i, ",").concat(j, "]: ").concat(JSON.stringify(s));
      }).join(", ");
    }).join(" -> ")), expr);
  }
  if (expr instanceof Call) {
    if (expr.children[0] instanceof Sym) {
      if (expr.children[0].value === "val") {
        if (expr.isAnon) {
          throw new EvalError("cannot call 'val' as anonymous function", expr);
        }
        if (expr.children[1] instanceof StringLiteral) {
          var path = expr.children[1].value;
          return newSelectorProxy(getSource(path), path);
        } else {
          throw new EvalError("argument of 'val' must be a string literal", expr);
        }
      } else if (expr.children[0].value === "json") {
        if (expr.children.length !== 2) {
          throw new EvalError("must call 'json' with exactly one argument", expr);
        }
        var value = evaluateSync(expr.children[1], getSource, stack);
        var valObj = value[SourceOrExpr];
        var valPath = value[Path];
        if (typeof valObj !== "string") {
          throw new EvalError("cannot parse JSON: ".concat(JSON.stringify(valObj), ", expected string"), expr.children[1]);
        }
        try {
          var serialized = JSON.parse(valObj);
          if (isSerializedVal(serialized)) {
            return newSelectorProxy(serialized.val, serialized.valPath);
          }
          var parsedValue = newSelectorProxy(JSON.parse(valObj), valPath);
          return parsedValue;
        } catch (e) {
          if (e instanceof SyntaxError) {
            throw new EvalError("cannot parse JSON: ".concat(valObj, ", ").concat(e.message, " - value: ").concat(JSON.stringify(value)), expr.children[1]);
          }
          throw e;
        }
      } else if (expr.children[0].value === "stringify") {
        // TODO: remove stringify
        if (expr.children.length !== 2) {
          throw new EvalError("must call 'stringify' with exactly one argument", expr);
        }
        var res = evaluateSync(expr.children[1], getSource, stack);
        return newSelectorProxy(JSON.stringify(res[SourceOrExpr]));
      }
    }
    var prop = evaluateSync(expr.children[0], getSource, stack)[SourceOrExpr];
    if (expr.children.length === 1) {
      // TODO: return if literal only?
      return newSelectorProxy(prop);
    }
    var obj = evaluateSync(expr.children[1], getSource, stack);
    if (typeof prop !== "string" && typeof prop !== "number") {
      throw new EvalError("cannot access ".concat(JSON.stringify(obj), " with property ").concat(JSON.stringify(prop), ": is not a string or number"), expr);
    }
    if (prop in obj) {
      if (expr.isAnon) {
        // anon functions:
        var maybeFunction = obj[prop];
        if (typeof maybeFunction !== "function") {
          throw new EvalError("cannot access property ".concat(JSON.stringify(prop), " of ").concat(JSON.stringify(obj), ": required higher ordered function got ").concat(_typeof(obj[prop])), expr);
        }
        if (expr.children[0] instanceof Sym) {
          return maybeFunction(function () {
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            return evaluateSync(expr.children[2], getSource, stack.concat([args]));
          });
        } else {
          throw new EvalError("cannot call an expression that is not a symbol, got: '".concat(expr.children[0].type, "'"), expr);
        }
      } else {
        // non-anon functions:
        if (expr.children[0] instanceof Sym) {
          if (expr.children[0].value === "val") {
            if (expr.children[1] instanceof StringLiteral) {
              var _path = expr.children[1].value;
              return newSelectorProxy(getSource(_path), _path);
            } else {
              throw new EvalError("argument of 'val' must be a string literal", expr);
            }
          }
        }
        var args = expr.children.slice(2);
        if (args.length > 0) {
          var _maybeFunction = obj[prop];
          if (typeof _maybeFunction !== "function") {
            throw new EvalError("cannot access property ".concat(JSON.stringify(prop), " of ").concat(JSON.stringify(obj), ": required function got ").concat(_typeof(obj[prop])), expr);
          }
          return _maybeFunction.apply(void 0, _toConsumableArray(args.map(function (arg) {
            return evaluateSync(arg, getSource, stack);
          })));
        }
        var maybeValue = obj[prop];
        if (typeof maybeValue === "function") {
          throw new EvalError("cannot access property ".concat(JSON.stringify(prop), " of ").concat(JSON.stringify(obj), ": required value got ").concat(_typeof(obj[prop])), expr);
        }
        return maybeValue;
      }
    }
  } else if (expr instanceof Sym) {
    if (expr.value.startsWith("@")) {
      var _stack$Number;
      var _expr$value$slice$spl = expr.value.slice(2, -1).split(","),
        _expr$value$slice$spl2 = _slicedToArray(_expr$value$slice$spl, 3),
        i = _expr$value$slice$spl2[0],
        j = _expr$value$slice$spl2[1],
        rest = _expr$value$slice$spl2[2];
      if (rest) {
        throw new EvalError("cannot access stack: too many indices", expr);
      }
      var stackValue = (_stack$Number = stack[Number(i)]) === null || _stack$Number === void 0 ? void 0 : _stack$Number[Number(j)];
      if (stackValue === undefined) {
        throw new EvalError("cannot access stack: out of bounds", expr);
      }
      return stackValue;
    } else if (expr.value === "()") {
      return newSelectorProxy(null);
    }
    return newSelectorProxy(expr.value);
  } else if (expr instanceof StringLiteral) {
    return newSelectorProxy(expr.value);
  } else if (expr instanceof StringTemplate) {
    return newSelectorProxy(expr.children.map(function (child) {
      if (child instanceof Sym && child.value === "()") {
        return "null";
      }
      var evalRes = evaluateSync(child, getSource, stack);
      if (child.type === "StringLiteral" || child.type === "StringTemplate") {
        return evalRes[SourceOrExpr];
      }
      if (Path in evalRes) {
        // a selector, so serialize to Val
        return JSON.stringify({
          val: evalRes[SourceOrExpr],
          valPath: evalRes[Path]
        });
      }
      return JSON.stringify(evalRes[SourceOrExpr]);
    }).join(""));
  }
  throw new EvalError("could not evaluate", expr);
}
function evaluate(expr, source, stack) {
  try {
    return ok(evaluateSync(expr, source, stack));
  } catch (err$1) {
    if (err$1 instanceof EvalError) {
      return err(err$1);
    }
    throw err$1;
  }
}

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  parse: parse,
  Call: Call,
  Expr: Expr,
  NilSym: NilSym,
  StringLiteral: StringLiteral,
  StringTemplate: StringTemplate,
  Sym: Sym,
  evaluate: evaluate
});

var ArraySchema = /*#__PURE__*/function (_Schema) {
  function ArraySchema(item) {
    var _this;
    var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    _classCallCheck(this, ArraySchema);
    _this = _callSuper(this, ArraySchema);
    _this.item = item;
    _this.opt = opt;
    return _this;
  }
  _inherits(ArraySchema, _Schema);
  return _createClass(ArraySchema, [{
    key: "validate",
    value: function validate(path, src) {
      var assertRes = this.assert(path, src);
      if (!assertRes.success) {
        return assertRes.errors;
      }
      if (assertRes.data === null) {
        return false;
      }
      var error = {};
      for (var _i = 0, _Object$entries = Object.entries(assertRes.data); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          idx = _Object$entries$_i[0],
          i = _Object$entries$_i[1];
        var subPath = unsafeCreateSourcePath(path, Number(idx));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var subError = this.item.validate(subPath, i);
        if (subError) {
          error = _objectSpread2(_objectSpread2({}, subError), error);
        }
      }
      if (Object.keys(error).length === 0) {
        return false;
      }
      return error;
    }
  }, {
    key: "assert",
    value: function assert(path, src) {
      if (src === null && this.opt) {
        return {
          success: true,
          data: src
        };
      }
      if (src === null) {
        return {
          success: false,
          errors: _defineProperty({}, path, [{
            message: "Expected 'array', got 'null'",
            typeError: true
          }])
        };
      }
      if (_typeof(src) !== "object") {
        return {
          success: false,
          errors: _defineProperty({}, path, [{
            message: "Expected 'object', got '".concat(_typeof(src), "'"),
            typeError: true
          }])
        };
      } else if (!Array.isArray(src)) {
        return {
          success: false,
          errors: _defineProperty({}, path, [{
            message: "Expected object of type 'array'",
            typeError: true
          }])
        };
      }
      return {
        success: true,
        data: src
      };
    }
  }, {
    key: "nullable",
    value: function nullable() {
      return new ArraySchema(this.item, true);
    }
  }, {
    key: "serialize",
    value: function serialize() {
      return {
        type: "array",
        item: this.item.serialize(),
        opt: this.opt
      };
    }
  }]);
}(Schema);
var array = function array(schema) {
  return new ArraySchema(schema);
};

var LiteralSchema = /*#__PURE__*/function (_Schema) {
  function LiteralSchema(value) {
    var _this;
    var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    _classCallCheck(this, LiteralSchema);
    _this = _callSuper(this, LiteralSchema);
    _this.value = value;
    _this.opt = opt;
    return _this;
  }
  _inherits(LiteralSchema, _Schema);
  return _createClass(LiteralSchema, [{
    key: "validate",
    value: function validate(path, src) {
      if (this.opt && (src === null || src === undefined)) {
        return false;
      }
      if (typeof src !== "string") {
        return _defineProperty({}, path, [{
          message: "Expected 'string', got '".concat(_typeof(src), "'"),
          value: src
        }]);
      }
      if (src !== this.value) {
        return _defineProperty({}, path, [{
          message: "Expected literal '".concat(this.value, "', got '").concat(src, "'"),
          value: src
        }]);
      }
      return false;
    }
  }, {
    key: "assert",
    value: function assert(path, src) {
      if (this.opt && src === null) {
        return {
          success: true,
          data: src
        };
      }
      if (src === null) {
        return {
          success: false,
          errors: _defineProperty({}, path, [{
            message: "Expected 'string', got 'null'",
            typeError: true
          }])
        };
      }
      if (typeof src === "string" && src === this.value) {
        return {
          success: true,
          data: src
        };
      }
      return {
        success: false,
        errors: _defineProperty({}, path, [{
          message: "Expected literal '".concat(this.value, "', got '").concat(src, "'"),
          typeError: true
        }])
      };
    }
  }, {
    key: "nullable",
    value: function nullable() {
      return new LiteralSchema(this.value, true);
    }
  }, {
    key: "serialize",
    value: function serialize() {
      return {
        type: "literal",
        value: this.value,
        opt: this.opt
      };
    }
  }]);
}(Schema);
var literal = function literal(value) {
  return new LiteralSchema(value);
};

var UnionSchema = /*#__PURE__*/function (_Schema) {
  function UnionSchema(key, items) {
    var _this;
    var opt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    _classCallCheck(this, UnionSchema);
    _this = _callSuper(this, UnionSchema);
    _this.key = key;
    _this.items = items;
    _this.opt = opt;
    return _this;
  }
  _inherits(UnionSchema, _Schema);
  return _createClass(UnionSchema, [{
    key: "validate",
    value: function validate(path, src) {
      var unknownSrc = src;
      var errors = false;
      if (this.opt && unknownSrc === null) {
        return false;
      }
      if (!this.key) {
        return _defineProperty({}, path, [{
          message: "Missing required first argument in union",
          schemaError: true
        }]);
      }
      var key = this.key;
      if (!Array.isArray(this.items)) {
        return _defineProperty({}, path, [{
          message: "A union schema must take more than 1 schema arguments",
          schemaError: true
        }]);
      }
      if (typeof key === "string") {
        // tagged union
        if (this.items.some(function (item) {
          return !(item instanceof ObjectSchema);
        })) {
          return _defineProperty({}, path, [{
            message: "Key is a string, so all schema items must be objects",
            schemaError: true
          }]);
        }
        var objectSchemas = this.items;
        var serializedSchemas = objectSchemas.map(function (schema) {
          return schema.serialize();
        });
        var illegalSchemas = serializedSchemas.filter(function (schema) {
          return !(schema.type === "object") || !(schema.items[key].type === "literal");
        });
        if (illegalSchemas.length > 0) {
          return _defineProperty({}, path, [{
            message: "All schema items must be objects with a key: ".concat(key, " that is a literal schema. Found: ").concat(JSON.stringify(illegalSchemas, null, 2)),
            schemaError: true
          }]);
        }
        var serializedObjectSchemas = serializedSchemas;
        var optionalLiterals = serializedObjectSchemas.filter(function (schema) {
          return schema.items[key].opt;
        });
        if (optionalLiterals.length > 1) {
          return _defineProperty({}, path, [{
            message: "Schema cannot have an optional keys: ".concat(key),
            schemaError: true
          }]);
        }
        if (_typeof(unknownSrc) !== "object") {
          return _defineProperty({}, path, [{
            message: "Expected an object",
            typeError: true
          }]);
        }
        var objectSrc = unknownSrc;
        if (objectSrc[key] === undefined) {
          return _defineProperty({}, path, [{
            message: "Missing required key: ".concat(key),
            typeError: true
          }]);
        }
        var foundSchemaLiterals = [];
        var _iterator = _createForOfIteratorHelper(serializedObjectSchemas),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var schema = _step.value;
            var schemaKey = schema.items[key];
            if (schemaKey.type === "literal") {
              if (!foundSchemaLiterals.includes(schemaKey.value)) {
                foundSchemaLiterals.push(schemaKey.value);
              } else {
                return _defineProperty({}, path, [{
                  message: "Found duplicate key in schema: ".concat(schemaKey.value),
                  schemaError: true
                }]);
              }
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        var objectSchemaAtKey = objectSchemas.find(function (schema) {
          return !schema.items[key].validate(path, objectSrc[key]);
        });
        if (!objectSchemaAtKey) {
          var keyPath = createValPathOfItem(path, key);
          if (!keyPath) {
            throw new Error("Internal error: could not create path at ".concat(!path && typeof path === "string" ? "<empty string>" : path, " at key ").concat(key));
          }
          return _defineProperty({}, keyPath, [{
            message: "Invalid key: \"".concat(key, "\". Value was: \"").concat(objectSrc[key], "\". Valid values: ").concat(serializedObjectSchemas.map(function (schema) {
              var keySchema = schema.items[key];
              if (keySchema.type === "literal" && keySchema.value) {
                return "\"".concat(keySchema.value, "\"");
              } else {
                // should not happen here, we already checked this
                throw new Error("Expected literal schema, got ".concat(JSON.stringify(keySchema, null, 2)));
              }
            }).join(", "))
          }]);
        }
        var error = objectSchemaAtKey.validate(path, objectSrc);
        if (error) {
          return error;
        }
      } else if (key instanceof LiteralSchema) {
        if (this.items.some(function (item) {
          return !(item instanceof LiteralSchema);
        })) {
          return _defineProperty({}, path, [{
            message: "Key is a literal schema, so all schema items must be literals",
            typeError: true
          }]);
        }
        var literalItems = [key].concat(_toConsumableArray(this.items));
        if (typeof unknownSrc === "string") {
          var isMatch = literalItems.some(function (item) {
            return !item.validate(path, unknownSrc);
          });
          if (!isMatch) {
            return _defineProperty({}, path, [{
              message: "Union must match one of the following: ".concat(literalItems.map(function (item) {
                return "\"".concat(item.value, "\"");
              }).join(", "))
            }]);
          }
        }
      } else {
        return _defineProperty({}, path, [{
          message: "Expected a string or literal"
        }]);
      }
      return errors;
    }
  }, {
    key: "assert",
    value: function assert(path, src) {
      if (this.opt && src === null) {
        return {
          success: true,
          data: src
        };
      }
      if (src === null) {
        return {
          success: false,
          errors: _defineProperty({}, path, [{
            message: "Expected 'object', got 'null'",
            typeError: true
          }])
        };
      }
      if (!this.key) {
        return {
          success: false,
          errors: _defineProperty({}, path, [{
            message: "Missing required first argument in union schema",
            schemaError: true
          }])
        };
      }
      if (!Array.isArray(this.items)) {
        return {
          success: false,
          errors: _defineProperty({}, path, [{
            message: "The schema of this value is wrong. Schema is neither a union of literals nor a tagged union (of objects)",
            schemaError: true
          }])
        };
      }
      if (this.key instanceof LiteralSchema) {
        var _ref13;
        var success = false;
        var errors = {};
        var _iterator2 = _createForOfIteratorHelper((_ref13 = [this.key]).concat.apply(_ref13, _toConsumableArray(this.items))),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var itemSchema = _step2.value;
            if (!(itemSchema instanceof LiteralSchema)) {
              return {
                success: false,
                errors: _defineProperty({}, path, [{
                  message: "Schema of value is a union of string, so all schema items must be literals",
                  schemaError: true
                }])
              };
            }
            if (typeof src !== "string") {
              errors[path] = [{
                message: "Expected 'string', got '".concat(_typeof(src), "'"),
                typeError: true
              }];
              continue;
            }
            var res = itemSchema.assert(path, src);
            if (res.success) {
              success = true;
              break;
            } else {
              for (var _i = 0, _Object$entries = Object.entries(res.errors); _i < _Object$entries.length; _i++) {
                var _errors5;
                var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
                  _key = _Object$entries$_i[0],
                  value = _Object$entries$_i[1];
                if (!errors[_key]) {
                  errors[_key] = [];
                }
                (_errors5 = errors[_key]).push.apply(_errors5, _toConsumableArray(value));
              }
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        if (!success) {
          return {
            success: false,
            errors: errors
          };
        }
        return {
          success: true,
          data: src
        };
      } else if (typeof this.key === "string") {
        var _success = false;
        var _errors6 = {};
        var _iterator3 = _createForOfIteratorHelper(this.items),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _itemSchema = _step3.value;
            var _res = _itemSchema.assert(path, src);
            if (_res.success) {
              _success = true;
              break;
            } else {
              for (var _i2 = 0, _Object$entries2 = Object.entries(_res.errors); _i2 < _Object$entries2.length; _i2++) {
                var _errors7;
                var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
                  _key2 = _Object$entries2$_i[0],
                  _value = _Object$entries2$_i[1];
                if (!_errors6[_key2]) {
                  _errors6[_key2] = [];
                }
                (_errors7 = _errors6[_key2]).push.apply(_errors7, _toConsumableArray(_value)); // by appending all type errors, we most likely get a lot of duplicate errors. Currently we believe this is correct though, but should probably be handled in when showing the errors to users
              }
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
        if (!_success) {
          return {
            success: false,
            errors: _errors6
          };
        }
        return {
          success: true,
          data: src
        };
      } else {
        return {
          success: false,
          errors: _defineProperty({}, path, [{
            message: "The schema of this value is wrong. Schema is neither a union of literals nor a tagged union (of objects)",
            schemaError: true
          }])
        };
      }
    }
  }, {
    key: "nullable",
    value: function nullable() {
      return new UnionSchema(this.key, this.items, true);
    }
  }, {
    key: "serialize",
    value: function serialize() {
      if (typeof this.key === "string") {
        return {
          type: "union",
          key: this.key,
          items: this.items.map(function (o) {
            return o.serialize();
          }),
          opt: this.opt
        };
      }
      return {
        type: "union",
        key: this.key.serialize(),
        items: this.items.map(function (o) {
          return o.serialize();
        }),
        opt: this.opt
      };
    }
  }]);
}(Schema);
var union = function union(key) {
  for (var _len = arguments.length, objects = new Array(_len > 1 ? _len - 1 : 0), _key3 = 1; _key3 < _len; _key3++) {
    objects[_key3 - 1] = arguments[_key3];
  }
  return new UnionSchema(key, objects);
};

var RichTextSchema = /*#__PURE__*/function (_Schema) {
  function RichTextSchema(options) {
    var _this;
    var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    _classCallCheck(this, RichTextSchema);
    _this = _callSuper(this, RichTextSchema);
    _this.options = options;
    _this.opt = opt;
    return _this;
  }
  _inherits(RichTextSchema, _Schema);
  return _createClass(RichTextSchema, [{
    key: "maxLength",
    value: function maxLength(max) {
      return new RichTextSchema(_objectSpread2(_objectSpread2({}, this.options), {}, {
        maxLength: max
      }), this.opt);
    }
  }, {
    key: "minLength",
    value: function minLength(min) {
      return new RichTextSchema(_objectSpread2(_objectSpread2({}, this.options), {}, {
        minLength: min
      }), this.opt);
    }
  }, {
    key: "validate",
    value: function validate(path, src) {
      var assertRes = this.assert(path, src);
      if (!assertRes.success) {
        return _defineProperty({}, path, assertRes.errors[path]);
      }
      var nodes = assertRes.data;
      if (nodes === null && this.opt) {
        return false;
      }
      if (nodes === null) {
        return _defineProperty({}, path, [{
          message: "Expected 'array', got 'null'",
          typeError: true
        }]);
      }
      var current = {};
      var typeErrorRes = this.internalValidate(path, nodes, current);
      if (typeErrorRes) {
        return typeErrorRes;
      }
      if (Object.keys(current).length > 0) {
        return current;
      }
      return false;
    }
  }, {
    key: "internalValidate",
    value: function internalValidate(rootPath, nodes, current) {
      var _this2 = this;
      var length = 0;
      var _recurse = function recurse(rootPath, nodes, current) {
        var addError = function addError(path, message, typeError) {
          if (!current[path]) {
            current[path] = [];
          }
          current[path].push({
            message: message,
            typeError: typeError
          });
        };
        var _iterator = _createForOfIteratorHelper(nodes),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _this2$options$block, _this2$options$block2, _this2$options$block3, _this2$options$block4, _this2$options$block5, _this2$options$block6, _this2$options$block7, _this2$options$block8, _this2$options$block9, _this2$options$block10, _this2$options$inline, _this2$options$inline2;
            var node = _step.value;
            var path = unsafeCreateSourcePath(rootPath, nodes.indexOf(node));
            if (typeof node === "string") {
              length += node.length;
              continue;
            }
            if (_typeof(node) !== "object") {
              return _defineProperty({}, path, [{
                message: "Expected nodes of type 'object' or 'string', got '".concat(_typeof(node), "'"),
                typeError: true
              }]);
            }
            if (node === null) {
              return _defineProperty({}, path, [{
                message: "Expected nodes of type 'object' or 'string', got 'null'",
                typeError: true
              }]);
            }
            if (!("tag" in node)) {
              return _defineProperty({}, path, [{
                message: "Expected node to either have 'tag' or be of type 'string'",
                typeError: true
              }]);
            }
            if (typeof node.tag !== "string") {
              return _defineProperty({}, path, [{
                message: "Expected 'string', got '".concat(_typeof(node.tag), "'"),
                typeError: true
              }]);
            }
            if (node.tag === "h1" && !((_this2$options$block = _this2.options.block) !== null && _this2$options$block !== void 0 && _this2$options$block.h1)) {
              addError(path, "'h' block is not valid", false);
            }
            if (node.tag === "h2" && !((_this2$options$block2 = _this2.options.block) !== null && _this2$options$block2 !== void 0 && _this2$options$block2.h2)) {
              addError(path, "'h2' block is not valid", false);
            }
            if (node.tag === "h3" && !((_this2$options$block3 = _this2.options.block) !== null && _this2$options$block3 !== void 0 && _this2$options$block3.h3)) {
              addError(path, "'h3' block is not valid", false);
            }
            if (node.tag === "h4" && !((_this2$options$block4 = _this2.options.block) !== null && _this2$options$block4 !== void 0 && _this2$options$block4.h4)) {
              addError(path, "'h4' block is not valid", false);
            }
            if (node.tag === "h5" && !((_this2$options$block5 = _this2.options.block) !== null && _this2$options$block5 !== void 0 && _this2$options$block5.h5)) {
              addError(path, "'h5' block is not valid", false);
            }
            if (node.tag === "h6" && !((_this2$options$block6 = _this2.options.block) !== null && _this2$options$block6 !== void 0 && _this2$options$block6.h6)) {
              addError(path, "'h6' block is not valid", false);
            }
            if (node.tag === "ol" && !((_this2$options$block7 = _this2.options.block) !== null && _this2$options$block7 !== void 0 && _this2$options$block7.ol)) {
              addError(path, "'ol' block is not valid", false);
            }
            if (node.tag === "ul" && !((_this2$options$block8 = _this2.options.block) !== null && _this2$options$block8 !== void 0 && _this2$options$block8.ul)) {
              addError(path, "'ul' block is not valid", false);
            }
            if (node.tag === "li" && !((_this2$options$block9 = _this2.options.block) !== null && _this2$options$block9 !== void 0 && _this2$options$block9.ul) && !((_this2$options$block10 = _this2.options.block) !== null && _this2$options$block10 !== void 0 && _this2$options$block10.ol)) {
              addError(path, "'li' tag is invalid since neither 'ul' nor 'ol' block is not valid", false);
            }
            if (node.tag === "a" && !((_this2$options$inline = _this2.options.inline) !== null && _this2$options$inline !== void 0 && _this2$options$inline.a)) {
              addError(path, "'a' inline is not valid", false);
            }
            if (node.tag === "img" && !((_this2$options$inline2 = _this2.options.inline) !== null && _this2$options$inline2 !== void 0 && _this2$options$inline2.img)) {
              addError(path, "'img' inline is not valid", false);
            }
            if ("styles" in node && node.tag !== "span") {
              return _defineProperty({}, path, [{
                message: "Cannot have styles on '".concat(node.tag, "'. This is only allowed on 'span'"),
                typeError: true
              }]);
            }
            if ("styles" in node) {
              if (!Array.isArray(node.styles)) {
                return _defineProperty({}, path, [{
                  message: "Expected 'array', got '".concat(_typeof(node.styles), "'"),
                  typeError: true
                }]);
              }
              var stylesPath = unsafeCreateSourcePath(path, "styles");
              for (var i = 0; i < node.styles.length; i++) {
                var _this2$options$style, _this2$options$style2, _this2$options$style3;
                var style = node.styles[i];
                var currentStylePath = unsafeCreateSourcePath(stylesPath, i);
                if (typeof style !== "string") {
                  return _defineProperty({}, currentStylePath, [{
                    message: "Expected 'string', got '".concat(_typeof(style), "'"),
                    typeError: true
                  }]);
                }
                if (style === "bold" && !((_this2$options$style = _this2.options.style) !== null && _this2$options$style !== void 0 && _this2$options$style.bold)) {
                  addError(currentStylePath, "Style 'bold' is not valid", false);
                }
                if (style === "italic" && !((_this2$options$style2 = _this2.options.style) !== null && _this2$options$style2 !== void 0 && _this2$options$style2.italic)) {
                  addError(currentStylePath, "Style 'italic' is not valid", false);
                }
                if (style === "lineThrough" && !((_this2$options$style3 = _this2.options.style) !== null && _this2$options$style3 !== void 0 && _this2$options$style3.lineThrough)) {
                  addError(currentStylePath, "Style 'lineThrough' is not valid", false);
                }
              }
            }
            if ("children" in node) {
              if (!Array.isArray(node.children)) {
                return _defineProperty({}, path, [{
                  message: "Expected 'array', got '".concat(_typeof(node.children), "'"),
                  typeError: true
                }]);
              }
              var children = node.children;
              for (var _i = 0; _i < children.length; _i++) {
                var child = children[_i];
                if (_typeof(child) === "object") {
                  var childPath = unsafeCreateSourcePath(path, "children");
                  var res = _recurse(childPath, [child], current);
                  if (res) {
                    return res;
                  }
                } else if (typeof child === "string") {
                  length += child.length;
                  continue;
                } else {
                  return _defineProperty({}, path, [{
                    message: "Expected 'object' or 'string', got '".concat(_typeof(child), "'"),
                    typeError: true
                  }]);
                }
              }
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        return false;
      };
      var results = _recurse(rootPath, nodes, current);
      var lengthErrors = [];
      if (this.options.maxLength && length > this.options.maxLength) {
        lengthErrors.push({
          message: "Maximum length of ".concat(this.options.maxLength, " exceeded (current length: ").concat(length, ")"),
          typeError: false
        });
      }
      if (this.options.minLength && length < this.options.minLength) {
        lengthErrors.push({
          message: "Minimum length of ".concat(this.options.minLength, " not met (current length: ").concat(length, ")"),
          typeError: false
        });
      }
      if (results) {
        if (lengthErrors.length > 0) {
          var _results$rootPath;
          if (!results[rootPath]) {
            results[rootPath] = [];
          }
          (_results$rootPath = results[rootPath]).push.apply(_results$rootPath, lengthErrors);
        }
        return results;
      }
      if (Object.keys(current).length > 0) {
        if (lengthErrors.length > 0) {
          var _current$rootPath;
          if (!current[rootPath]) {
            current[rootPath] = [];
          }
          (_current$rootPath = current[rootPath]).push.apply(_current$rootPath, lengthErrors);
        }
        return current;
      }
      if (lengthErrors.length > 0) {
        return _defineProperty({}, rootPath, lengthErrors);
      }
      return false;
    }
  }, {
    key: "assert",
    value: function assert(path, src) {
      if (this.opt && src === null) {
        return {
          success: true,
          data: src
        };
      }
      if (src === null && !this.opt) {
        return {
          success: false,
          errors: _defineProperty({}, path, [{
            message: "Expected 'array', got 'null'",
            typeError: true
          }])
        };
      }
      if (!Array.isArray(src)) {
        return {
          success: false,
          errors: _defineProperty({}, path, [{
            message: "Expected 'array', got '".concat(_typeof(src), "'"),
            typeError: true
          }])
        };
      }
      var errors = {};
      for (var i = 0; i < src.length; i++) {
        this.recursiveAssert(unsafeCreateSourcePath(path, i), src[i], errors);
      }
      if (Object.keys(errors).length > 0) {
        return {
          success: false,
          errors: errors
        };
      }
      // TODO: validate options
      return {
        success: true,
        data: src
      };
    }
  }, {
    key: "recursiveAssert",
    value: function recursiveAssert(path, node, errors) {
      if (_typeof(node) !== "object") {
        if (!errors[path]) {
          errors[path] = [];
        }
        errors[path].push({
          message: "Expected 'object', got '".concat(_typeof(node), "'"),
          typeError: true
        });
        return;
      }
      if (Array.isArray(node)) {
        if (!errors[path]) {
          errors[path] = [];
        }
        errors[path].push({
          message: "Expected 'object', got 'array'",
          typeError: true
        });
        return;
      }
      if (node === null) {
        if (!errors[path]) {
          errors[path] = [];
        }
        errors[path].push({
          message: "Expected 'object', got 'null'",
          typeError: true
        });
        return;
      }
      if ("tag" in node) {
        if (typeof node.tag !== "string") {
          if (!errors[path]) {
            errors[path] = [];
          }
          errors[path].push({
            message: "Expected 'string', got '".concat(_typeof(node.tag), "'"),
            typeError: true
          });
          return;
        }
      }
      if ("children" in node) {
        if (!Array.isArray(node.children)) {
          if (!errors[path]) {
            errors[path] = [];
          }
          errors[path].push({
            message: "Expected 'array', got '".concat(_typeof(node.children), "'"),
            typeError: true
          });
          return;
        } else {
          for (var i = 0; i < node.children.length; i++) {
            var child = node.children[i];
            var pathAtError = unsafeCreateSourcePath(unsafeCreateSourcePath(path, "children"), i);
            if (_typeof(child) === "object") {
              this.recursiveAssert(pathAtError, child, errors);
            } else if (typeof child === "string") {
              continue;
            } else {
              if (!errors[pathAtError]) {
                errors[pathAtError] = [];
              }
              errors[pathAtError].push({
                message: "Expected 'object' or 'string', got '".concat(_typeof(child), "'"),
                typeError: true
              });
            }
          }
        }
      }
      if ("styles" in node) {
        if (!Array.isArray(node.styles)) {
          if (!errors[path]) {
            errors[path] = [];
          }
          errors[path].push({
            message: "Expected 'array', got '".concat(_typeof(node.styles), "'"),
            typeError: true
          });
        } else {
          for (var _i2 = 0; _i2 < node.styles.length; _i2++) {
            var style = node.styles[_i2];
            if (typeof style !== "string") {
              var _pathAtError = unsafeCreateSourcePath(path, _i2);
              if (!errors[_pathAtError]) {
                errors[_pathAtError] = [];
              }
              errors[_pathAtError].push({
                message: "Expected 'string', got '".concat(_typeof(style), "'"),
                typeError: true
              });
            }
          }
        }
      }
    }
  }, {
    key: "nullable",
    value: function nullable() {
      return new RichTextSchema(this.options, true);
    }
  }, {
    key: "serialize",
    value: function serialize() {
      return {
        type: "richtext",
        opt: this.opt,
        options: this.options
      };
    }
  }]);
}(Schema);
var richtext = function richtext(options) {
  return new RichTextSchema(options !== null && options !== void 0 ? options : {});
};

var ImageSchema = /*#__PURE__*/function (_Schema) {
  function ImageSchema(options) {
    var _this;
    var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    _classCallCheck(this, ImageSchema);
    _this = _callSuper(this, ImageSchema);
    _this.options = options;
    _this.opt = opt;
    return _this;
  }
  _inherits(ImageSchema, _Schema);
  return _createClass(ImageSchema, [{
    key: "validate",
    value: function validate(path, src) {
      if (this.opt && (src === null || src === undefined)) {
        return false;
      }
      if (src === null || src === undefined) {
        return _defineProperty({}, path, [{
          message: "Non-optional image was null or undefined.",
          value: src
        }]);
      }
      if (typeof src[FILE_REF_PROP] !== "string") {
        return _defineProperty({}, path, [{
          message: "Image did not have a file reference string. Got: ".concat(_typeof(src[FILE_REF_PROP])),
          value: src
        }]);
      }
      if (src[VAL_EXTENSION] !== "file") {
        return _defineProperty({}, path, [{
          message: "Image did not have the valid file extension type. Got: ".concat(src[VAL_EXTENSION]),
          value: src,
          fixes: ["image:change-extension", "image:check-metadata"]
        }]);
      }
      var _ref4 = this.options || {},
        accept = _ref4.accept;
      var _ref5 = src.metadata || {},
        mimeType = _ref5.mimeType;
      if (accept && mimeType && !mimeType.includes("/")) {
        return _defineProperty({}, path, [{
          message: "Invalid mime type format. Got: '".concat(mimeType, "'"),
          value: src,
          fixes: ["image:check-metadata"]
        }]);
      }
      if (accept && mimeType && mimeType.includes("/")) {
        var acceptedTypes = accept.split(",").map(function (type) {
          return type.trim();
        });
        var isValidMimeType = acceptedTypes.some(function (acceptedType) {
          if (acceptedType === "*/*") {
            return true;
          }
          if (acceptedType.endsWith("/*")) {
            var baseType = acceptedType.slice(0, -2);
            return mimeType.startsWith(baseType);
          }
          return acceptedType === mimeType;
        });
        if (!isValidMimeType) {
          return _defineProperty({}, path, [{
            message: "Mime type mismatch. Found '".concat(mimeType, "' but schema accepts '").concat(accept, "'"),
            value: src,
            fixes: ["image:check-metadata"]
          }]);
        }
      }
      var fileMimeType = Internal.filenameToMimeType(src[FILE_REF_PROP]);
      if (!fileMimeType) {
        return _defineProperty({}, path, [{
          message: "Could not determine mime type from file extension. Got: ".concat(src[FILE_REF_PROP]),
          value: src,
          fixes: ["image:check-metadata"]
        }]);
      }
      if (fileMimeType && mimeType && fileMimeType !== mimeType) {
        return _defineProperty({}, path, [{
          message: "Mime type and file extension not matching. Mime type is '".concat(mimeType, "' but file extension is '").concat(fileMimeType, "'"),
          value: src,
          fixes: ["image:check-metadata"]
        }]);
      }
      if (src.metadata) {
        if (src.metadata.hotspot) {
          if (_typeof(src.metadata.hotspot) !== "object" || typeof src.metadata.hotspot.x !== "number" || typeof src.metadata.hotspot.y !== "number") {
            return _defineProperty({}, path, [{
              message: "Hotspot must be an object with x and y as numbers.",
              value: src
            }]);
          }
        }
        return _defineProperty({}, path, [{
          message: "Found metadata, but it could not be validated. Image metadata must be an object with the required props: width (positive number), height (positive number) and the mime type.",
          // These validation errors will have to be picked up by logic outside of this package and revalidated. Reasons: 1) we have to read files to verify the metadata, which is handled differently in different runtimes (Browser, QuickJS, Node.js); 2) we want to keep this package dependency free.
          value: src,
          fixes: ["image:check-metadata"]
        }]);
      }
      return _defineProperty({}, path, [{
        message: "Could not validate Image metadata.",
        value: src,
        fixes: ["image:add-metadata"]
      }]);
    }
  }, {
    key: "assert",
    value: function assert(path, src) {
      if (this.opt && src === null) {
        return {
          success: true,
          data: src
        };
      }
      if (src === null) {
        return {
          success: false,
          errors: _defineProperty({}, path, [{
            message: "Expected 'object', got 'null'",
            typeError: true
          }])
        };
      }
      if (_typeof(src) !== "object") {
        return {
          success: false,
          errors: _defineProperty({}, path, [{
            message: "Expected 'object', got '".concat(_typeof(src), "'"),
            typeError: true
          }])
        };
      }
      if (!(FILE_REF_PROP in src)) {
        return {
          success: false,
          errors: _defineProperty({}, path, [{
            message: "Value of this schema must use: 'c.image' (error type: missing_ref_prop)",
            typeError: true
          }])
        };
      }
      if (!(VAL_EXTENSION in src && src[VAL_EXTENSION] === "file")) {
        return {
          success: false,
          errors: _defineProperty({}, path, [{
            message: "Value of this schema must use: 'c.image' (error type: missing_file_extension)",
            typeError: true
          }])
        };
      }
      return {
        success: true,
        data: src
      };
    }
  }, {
    key: "nullable",
    value: function nullable() {
      return new ImageSchema(this.options, true);
    }
  }, {
    key: "serialize",
    value: function serialize() {
      return {
        type: "image",
        options: this.options,
        opt: this.opt
      };
    }
  }]);
}(Schema);
var image = function image(options) {
  return new ImageSchema(options);
};

var RecordSchema = /*#__PURE__*/function (_Schema) {
  function RecordSchema(item) {
    var _this;
    var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    _classCallCheck(this, RecordSchema);
    _this = _callSuper(this, RecordSchema);
    _this.item = item;
    _this.opt = opt;
    return _this;
  }
  _inherits(RecordSchema, _Schema);
  return _createClass(RecordSchema, [{
    key: "validate",
    value: function validate(path, src) {
      var _this2 = this;
      var error = false;
      if (this.opt && (src === null || src === undefined)) {
        return false;
      }
      if (src === null) {
        return _defineProperty({}, path, [{
          message: "Expected 'object', got 'null'"
        }]);
      }
      if (_typeof(src) !== "object") {
        return _defineProperty({}, path, [{
          message: "Expected 'object', got '".concat(_typeof(src), "'")
        }]);
      }
      if (Array.isArray(src)) {
        return _defineProperty({}, path, [{
          message: "Expected 'object', got 'array'"
        }]);
      }
      Object.entries(src).forEach(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
          key = _ref5[0],
          elem = _ref5[1];
        var subPath = createValPathOfItem(path, key);
        if (!subPath) {
          error = _this2.appendValidationError(error, path, "Internal error: could not create path at ".concat(!path && typeof path === "string" ? "<empty string>" : path, " at key ").concat(elem),
          // Should! never happen
          src);
        } else {
          var subError = _this2.item.validate(subPath, elem);
          if (subError && error) {
            error = _objectSpread2(_objectSpread2({}, subError), error);
          } else if (subError) {
            error = subError;
          }
        }
      });
      return error;
    }
  }, {
    key: "assert",
    value: function assert(path, src) {
      if (this.opt && src === null) {
        return {
          success: true,
          data: src
        };
      }
      if (_typeof(src) !== "object") {
        return {
          success: false,
          errors: _defineProperty({}, path, [{
            message: "Expected 'object', got '".concat(_typeof(src), "'"),
            typeError: true
          }])
        };
      }
      if (Array.isArray(src)) {
        return {
          success: false,
          errors: _defineProperty({}, path, [{
            message: "Expected 'object', got 'array'",
            typeError: true
          }])
        };
      }
      return {
        success: true,
        data: src
      };
    }
  }, {
    key: "nullable",
    value: function nullable() {
      return new RecordSchema(this.item, true);
    }
  }, {
    key: "serialize",
    value: function serialize() {
      return {
        type: "record",
        item: this.item.serialize(),
        opt: this.opt
      };
    }
  }]);
}(Schema);
var record = function record(schema) {
  return new RecordSchema(schema);
};

function define(
// eslint-disable-next-line @typescript-eslint/no-unused-vars
id,
// TODO: `/${string}`
// eslint-disable-next-line @typescript-eslint/no-unused-vars
schema,
// eslint-disable-next-line @typescript-eslint/no-unused-vars
source) {
  return _defineProperty(_defineProperty(_defineProperty({}, GetSource, source), GetSchema$1, schema), Path$1, id);
}
function getSource(valModule) {
  var sourceOrExpr = valModule[GetSource];
  if (sourceOrExpr instanceof Expr) {
    throw Error("Cannot get raw source of an Expr");
  }
  var source = sourceOrExpr;
  return source;
}
function splitModuleFilePathAndModulePath(path) {
  var pathOfSep = path.indexOf(ModuleFilePathSep);
  if (pathOfSep === -1) {
    return [path, ""];
  }
  return [path.slice(0, pathOfSep), path.slice(pathOfSep + ModuleFilePathSep.length)];
}
function joinModuleFilePathAndModulePath(moduleFilePath, modulePath) {
  if (modulePath === "") {
    return moduleFilePath;
  }
  return "".concat(moduleFilePath).concat(ModuleFilePathSep).concat(modulePath);
}
function isObjectSchema(schema) {
  return schema instanceof ObjectSchema || _typeof(schema) === "object" && "type" in schema && schema.type === "object";
}
function isRecordSchema(schema) {
  return schema instanceof RecordSchema || _typeof(schema) === "object" && "type" in schema && schema.type === "record";
}
function isArraySchema(schema) {
  return schema instanceof ArraySchema || _typeof(schema) === "object" && "type" in schema && schema.type === "array";
}

// function isI18nSchema(
//   schema: Schema<SelectorSource> | SerializedSchema
// ): schema is I18nSchema<readonly string[]> | SerializedI18nSchema {
//   return (
//     schema instanceof I18nSchema ||
//     (typeof schema === "object" && "type" in schema && schema.type === "i18n")
//   );
// }

function isUnionSchema(schema
// eslint-disable-next-line @typescript-eslint/no-explicit-any
) {
  return schema instanceof UnionSchema || _typeof(schema) === "object" && "type" in schema && schema.type === "union";
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function isRichTextSchema(schema) {
  return schema instanceof RichTextSchema || _typeof(schema) === "object" && "type" in schema && schema.type === "richtext";
}
function isImageSchema(schema) {
  return schema instanceof ImageSchema || _typeof(schema) === "object" && "type" in schema && schema.type === "image";
}

// function isOneOfSchema(
//   schema: Schema<SelectorSource> | SerializedSchema
// ): schema is OneOfSchema<GenericSelector<SourceArray>> | SerializedOneOfSchema {
//   return (
//     schema instanceof OneOfSchema ||
//     (typeof schema === "object" && "type" in schema && schema.type === "oneOf")
//   );
// }

function resolvePath(path, valModule, schema) {
  var parts = splitModulePath(path);
  var origParts = _toConsumableArray(parts);
  var resolvedSchema = schema;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var resolvedSource = valModule;
  var _loop = function _loop() {
      var part = parts.shift();
      if (part === undefined) {
        throw Error("Unexpected undefined part");
      }
      if (isArraySchema(resolvedSchema)) {
        if (Number.isNaN(Number(part))) {
          throw Error("Invalid path: array schema ".concat(JSON.stringify(resolvedSchema), " must have a number as path, but got ").concat(part, ". Path: ").concat(path));
        }
        if (_typeof(resolvedSource) !== "object" && !Array.isArray(resolvedSource)) {
          throw Error("Schema type error: expected source to be type of array, but got ".concat(_typeof(resolvedSource)));
        }
        resolvedSource = resolvedSource[part];
        resolvedSchema = resolvedSchema.item;
      } else if (isRecordSchema(resolvedSchema)) {
        if (typeof part !== "string") {
          throw Error("Invalid path: record schema ".concat(resolvedSchema, " must have path: ").concat(part, " as string"));
        }
        if (_typeof(resolvedSource) !== "object" && !Array.isArray(resolvedSource)) {
          throw Error("Schema type error: expected source to be type of record, but got ".concat(_typeof(resolvedSource)));
        }
        if (!resolvedSource[part]) {
          throw Error("Invalid path: record source did not have key ".concat(part, " from path: ").concat(path));
        }
        resolvedSource = resolvedSource[part];
        resolvedSchema = resolvedSchema.item;
      } else if (isObjectSchema(resolvedSchema)) {
        if (_typeof(resolvedSource) !== "object") {
          throw Error("Schema type error: expected source to be type of object, but got ".concat(_typeof(resolvedSource)));
        }
        if (resolvedSource !== null && resolvedSource[part] === undefined) {
          throw Error("Invalid path: object source did not have key ".concat(part, " from path: ").concat(path));
        }
        resolvedSource = resolvedSource === null ? resolvedSource : resolvedSource[part];
        resolvedSchema = resolvedSchema.items[part];
        // } else if (isI18nSchema(resolvedSchema)) {
        //   if (!resolvedSchema.locales.includes(part)) {
        //     throw Error(
        //       `Invalid path: i18n schema ${resolvedSchema} supports locales ${resolvedSchema.locales.join(
        //         ", "
        //       )}, but found: ${part}`
        //     );
        //   }
        //   if (!Object.keys(resolvedSource).includes(part)) {
        //     throw Error(
        //       `Schema type error: expected source to be type of i18n with locale ${part}, but got ${JSON.stringify(
        //         Object.keys(resolvedSource)
        //       )}`
        //     );
        //   }
        //   resolvedSource = resolvedSource[part];
        //   resolvedSchema = resolvedSchema.item;
      } else if (isImageSchema(resolvedSchema)) {
        return {
          v: {
            path: origParts.slice(0, origParts.length - parts.length - 1).map(function (p) {
              return JSON.stringify(p);
            }).join("."),
            // TODO: create a function generate path from parts (not sure if this always works)
            schema: resolvedSchema,
            source: resolvedSource
          }
        };
      } else if (isUnionSchema(resolvedSchema)) {
        var _key = resolvedSchema.key;
        if (typeof _key !== "string") {
          return {
            v: {
              path: origParts.map(function (p) {
                if (!Number.isNaN(Number(p))) {
                  return p;
                } else {
                  return JSON.stringify(p);
                }
              }).join("."),
              // TODO: create a function generate path from parts (not sure if this always works)
              schema: resolvedSchema,
              source: resolvedSource
            }
          };
        }
        var keyValue = resolvedSource[_key];
        if (!keyValue) {
          throw Error("Invalid path: union source ".concat(resolvedSchema, " did not have required key ").concat(_key, " in path: ").concat(path));
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var schemaOfUnionKey = resolvedSchema.items.find(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        function (child) {
          var _child$items;
          return (child === null || child === void 0 || (_child$items = child.items) === null || _child$items === void 0 || (_child$items = _child$items[_key]) === null || _child$items === void 0 ? void 0 : _child$items.value) === keyValue;
        });
        if (!schemaOfUnionKey) {
          throw Error("Invalid path: union schema ".concat(resolvedSchema, " did not have a child object with ").concat(_key, " of value ").concat(keyValue, " in path: ").concat(path));
        }
        resolvedSchema = schemaOfUnionKey.items[part];
        resolvedSource = resolvedSource[part];
      } else if (isRichTextSchema(resolvedSchema)) {
        return {
          v: {
            path: origParts.slice(0, origParts.length - parts.length - 1).map(function (p) {
              return JSON.stringify(p);
            }).join("."),
            // TODO: create a function generate path from parts (not sure if this always works)
            schema: resolvedSchema,
            source: resolvedSource
          }
        };
      } else {
        throw Error("Invalid path: ".concat(part, " resolved to an unexpected schema ").concat(JSON.stringify(resolvedSchema)));
      }
    },
    _ret;
  while (parts.length > 0) {
    _ret = _loop();
    if (_ret) return _ret.v;
  }
  if (parts.length > 0) {
    throw Error("Invalid path: ".concat(parts.join("."), " is not a valid path"));
  }
  return {
    path: origParts.map(function (p) {
      if (!Number.isNaN(Number(p))) {
        return p;
      } else {
        return JSON.stringify(p);
      }
    }).join("."),
    // TODO: create a function generate path from parts (not sure if this always works)
    schema: resolvedSchema,
    source: resolvedSource
  };
}
function splitModuleFilePath(input) {
  var parts = input.split("/").slice(1);
  return parts;
}
function splitModulePath(input) {
  var result = [];
  var i = 0;
  while (i < input.length) {
    var part = "";
    if (input[i] === '"') {
      // Parse a quoted string
      i++;
      while (i < input.length && input[i] !== '"') {
        if (input[i] === "\\" && input[i + 1] === '"') {
          // Handle escaped double quotes
          part += '"';
          i++;
        } else {
          part += input[i];
        }
        i++;
      }
      if (input[i] !== '"') {
        var _input$i;
        throw new Error("Invalid input (".concat(JSON.stringify(input), "): Missing closing double quote: ").concat((_input$i = input[i]) !== null && _input$i !== void 0 ? _input$i : "at end of string", " (char: ").concat(i, "; length: ").concat(input.length, ")"));
      }
    } else {
      // Parse a regular string
      while (i < input.length && input[i] !== ".") {
        part += input[i];
        i++;
      }
    }
    if (part !== "") {
      result.push(part);
    }
    i++;
  }
  return result;
}
function splitJoinedSourcePaths(input) {
  // TODO: This is a very simple implementation that does not handle escaped commas
  return input.split(",");
}
function parentOfSourcePath(sourcePath) {
  var _splitModuleFilePathA = splitModuleFilePathAndModulePath(sourcePath),
    _splitModuleFilePathA2 = _slicedToArray(_splitModuleFilePathA, 2),
    moduleFilePath = _splitModuleFilePathA2[0],
    modulePath = _splitModuleFilePathA2[1];
  var modulePathParts = splitModulePath(modulePath).slice(0, -1);
  if (modulePathParts.length > 0) {
    return joinModuleFilePathAndModulePath(moduleFilePath, patchPathToModulePath(modulePathParts));
  }
  return moduleFilePath;
}
function patchPathToModulePath(patchPath) {
  return patchPath.map(function (segment) {
    // TODO: I am worried that something is lost here: what if the segment is a string that happens to be a parsable as a number? We could make those keys illegal?
    if (Number.isInteger(Number(segment))) {
      return segment;
    }
    return JSON.stringify(segment);
  }).join(".");
}

var NumberSchema = /*#__PURE__*/function (_Schema) {
  function NumberSchema(options) {
    var _this;
    var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    _classCallCheck(this, NumberSchema);
    _this = _callSuper(this, NumberSchema);
    _this.options = options;
    _this.opt = opt;
    return _this;
  }
  _inherits(NumberSchema, _Schema);
  return _createClass(NumberSchema, [{
    key: "validate",
    value: function validate(path, src) {
      if (this.opt && (src === null || src === undefined)) {
        return false;
      }
      if (typeof src !== "number") {
        return _defineProperty({}, path, [{
          message: "Expected 'number', got '".concat(_typeof(src), "'"),
          value: src
        }]);
      }
      return false;
    }
  }, {
    key: "assert",
    value: function assert(path, src) {
      if (this.opt && src === null) {
        return {
          success: true,
          data: src
        };
      }
      if (src === null) {
        return {
          success: false,
          errors: _defineProperty({}, path, [{
            message: "Expected 'number', got 'null'",
            typeError: true
          }])
        };
      }
      if (typeof src === "number") {
        return {
          success: true,
          data: src
        };
      }
      return {
        success: false,
        errors: _defineProperty({}, path, [{
          message: "Expected 'number', got '".concat(_typeof(src), "'"),
          typeError: true
        }])
      };
    }
  }, {
    key: "nullable",
    value: function nullable() {
      return new NumberSchema(this.options, true);
    }
  }, {
    key: "serialize",
    value: function serialize() {
      return {
        type: "number",
        options: this.options,
        opt: this.opt
      };
    }
  }]);
}(Schema);
var number = function number(options) {
  return new NumberSchema(options);
};

var StringSchema = /*#__PURE__*/function (_Schema) {
  function StringSchema(options) {
    var _this;
    var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var isRaw = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    _classCallCheck(this, StringSchema);
    _this = _callSuper(this, StringSchema);
    _this.options = options;
    _this.opt = opt;
    _this.isRaw = isRaw;
    return _this;
  }

  /**
   * @deprecated Use `minLength` instead
   */
  _inherits(StringSchema, _Schema);
  return _createClass(StringSchema, [{
    key: "min",
    value: function min(minLength) {
      return this.minLength(minLength);
    }
  }, {
    key: "minLength",
    value: function minLength(_minLength) {
      return new StringSchema(_objectSpread2(_objectSpread2({}, this.options), {}, {
        minLength: _minLength
      }), this.opt, this.isRaw);
    }

    /**
     * @deprecated Use `maxLength` instead
     */
  }, {
    key: "max",
    value: function max(maxLength) {
      return this.maxLength(maxLength);
    }
  }, {
    key: "maxLength",
    value: function maxLength(_maxLength) {
      return new StringSchema(_objectSpread2(_objectSpread2({}, this.options), {}, {
        maxLength: _maxLength
      }), this.opt, this.isRaw);
    }
  }, {
    key: "regexp",
    value: function regexp(_regexp) {
      return new StringSchema(_objectSpread2(_objectSpread2({}, this.options), {}, {
        regexp: _regexp
      }), this.opt, this.isRaw);
    }
  }, {
    key: "validate",
    value: function validate(path, src) {
      var _this$options, _this$options2, _this$options3;
      if (this.opt && (src === null || src === undefined)) {
        return false;
      }
      if (typeof src !== "string") {
        return _defineProperty({}, path, [{
          message: "Expected 'string', got '".concat(_typeof(src), "'"),
          value: src
        }]);
      }
      var errors = [];
      if ((_this$options = this.options) !== null && _this$options !== void 0 && _this$options.maxLength && src.length > this.options.maxLength) {
        errors.push({
          message: "Expected string to be at most ".concat(this.options.maxLength, " characters long, got ").concat(src.length),
          value: src
        });
      }
      if ((_this$options2 = this.options) !== null && _this$options2 !== void 0 && _this$options2.minLength && src.length < this.options.minLength) {
        errors.push({
          message: "Expected string to be at least ".concat(this.options.minLength, " characters long, got ").concat(src.length),
          value: src
        });
      }
      if ((_this$options3 = this.options) !== null && _this$options3 !== void 0 && _this$options3.regexp && !this.options.regexp.test(src)) {
        errors.push({
          message: "Expected string to match reg exp: ".concat(this.options.regexp.toString(), ", got '").concat(src, "'"),
          value: src
        });
      }
      if (errors.length > 0) {
        return _defineProperty({}, path, errors);
      }
      return false;
    }
  }, {
    key: "assert",
    value: function assert(path, src) {
      if (this.opt && src === null) {
        return {
          success: true,
          data: src
        };
      }
      if (typeof src === "string") {
        return {
          success: true,
          data: src
        };
      }
      return {
        success: false,
        errors: _defineProperty({}, path, [{
          message: "Expected 'string', got '".concat(_typeof(src), "'"),
          typeError: true
        }])
      };
    }
  }, {
    key: "nullable",
    value: function nullable() {
      return new StringSchema(this.options, true, this.isRaw);
    }
  }, {
    key: "raw",
    value: function raw() {
      return new StringSchema(this.options, this.opt, true);
    }
  }, {
    key: "serialize",
    value: function serialize() {
      var _this$options4, _this$options5, _this$options6;
      return {
        type: "string",
        options: {
          maxLength: (_this$options4 = this.options) === null || _this$options4 === void 0 ? void 0 : _this$options4.maxLength,
          minLength: (_this$options5 = this.options) === null || _this$options5 === void 0 ? void 0 : _this$options5.minLength,
          regexp: ((_this$options6 = this.options) === null || _this$options6 === void 0 ? void 0 : _this$options6.regexp) && {
            source: this.options.regexp.source,
            flags: this.options.regexp.flags
          }
        },
        opt: this.opt,
        raw: this.isRaw
      };
    }
  }]);
}(Schema);
var string = function string(options) {
  return new StringSchema(options);
};

var BooleanSchema = /*#__PURE__*/function (_Schema) {
  function BooleanSchema() {
    var _this;
    var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    _classCallCheck(this, BooleanSchema);
    _this = _callSuper(this, BooleanSchema);
    _this.opt = opt;
    return _this;
  }
  _inherits(BooleanSchema, _Schema);
  return _createClass(BooleanSchema, [{
    key: "validate",
    value: function validate(path, src) {
      if (this.opt && (src === null || src === undefined)) {
        return false;
      }
      if (typeof src !== "boolean") {
        return _defineProperty({}, path, [{
          message: "Expected 'boolean', got '".concat(_typeof(src), "'"),
          value: src
        }]);
      }
      return false;
    }
  }, {
    key: "assert",
    value: function assert(path, src) {
      if (this.opt && src === null) {
        return {
          success: true,
          data: src
        };
      }
      if (src === null) {
        return {
          success: false,
          errors: _defineProperty({}, path, [{
            message: "Expected 'boolean', got 'null'",
            typeError: true
          }])
        };
      }
      if (typeof src !== "boolean") {
        return {
          success: false,
          errors: _defineProperty({}, path, [{
            message: "Expected 'boolean', got '".concat(_typeof(src), "'"),
            typeError: true
          }])
        };
      }
      return {
        success: true,
        data: src
      };
    }
  }, {
    key: "nullable",
    value: function nullable() {
      return new BooleanSchema(true);
    }
  }, {
    key: "serialize",
    value: function serialize() {
      return {
        type: "boolean",
        opt: this.opt
      };
    }
  }]);
}(Schema);
var _boolean = function _boolean() {
  return new BooleanSchema();
};

var KeyOfSchema = /*#__PURE__*/function (_Schema) {
  function KeyOfSchema(schema, sourcePath) {
    var _this;
    var opt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    _classCallCheck(this, KeyOfSchema);
    _this = _callSuper(this, KeyOfSchema);
    _this.schema = schema;
    _this.sourcePath = sourcePath;
    _this.opt = opt;
    return _this;
  }
  _inherits(KeyOfSchema, _Schema);
  return _createClass(KeyOfSchema, [{
    key: "validate",
    value: function validate(path, src) {
      if (this.opt && (src === null || src === undefined)) {
        return false;
      }
      if (!this.schema) {
        return _defineProperty({}, path, [{
          message: "Schema not found for module. keyOf must be used with a Val Module"
        }]);
      }
      var serializedSchema = this.schema;
      if (!(serializedSchema.type === "object" || serializedSchema.type === "record")) {
        return _defineProperty({}, path, [{
          message: "Schema in keyOf must be an 'object' or 'record'. Found '".concat(serializedSchema.type, "'")
        }]);
      }
      if (serializedSchema.opt && (src === null || src === undefined)) {
        return false;
      }
      if (serializedSchema.type === "record" && typeof src !== "string") {
        return _defineProperty({}, path, [{
          message: "Type of value in keyof (record) must be 'string'"
        }]);
      }
      if (serializedSchema.type === "object") {
        var keys = Object.keys(serializedSchema.items);
        if (!keys.includes(src)) {
          return _defineProperty({}, path, [{
            message: "Value of keyOf (object) must be: ".concat(keys.join(", "), ". Found: ").concat(src)
          }]);
        }
      }
      if (serializedSchema.type === "record") {
        if (typeof src !== "string") {
          return _defineProperty({}, path, [{
            message: "Value of keyOf (record) must be 'string'. Found: ".concat(_typeof(src))
          }]);
        }
        return _defineProperty({}, path, [{
          fixes: ["keyof:check-keys"],
          message: "Did not validate keyOf (record). This error (keyof:check-keys) should typically be processed by Val internally. Seeing this error most likely means you have a Val version mismatch.",
          value: {
            key: src,
            sourcePath: this.sourcePath
          }
        }]);
      }
      return false;
    }
  }, {
    key: "assert",
    value: function assert(path, src) {
      if (this.opt && src === null) {
        return {
          success: true,
          data: src
        };
      }
      if (src === null) {
        return {
          success: false,
          errors: _defineProperty({}, path, [{
            message: "Expected 'string', got 'null'",
            typeError: true
          }])
        };
      }
      var schema = this.schema;
      if (!schema) {
        return {
          success: false,
          errors: _defineProperty({}, path, [{
            message: "Neither key nor schema was found. keyOf is missing an argument.",
            typeError: true
          }])
        };
      }
      var serializedSchema = schema;
      if (!(serializedSchema.type === "object" || serializedSchema.type === "record")) {
        return {
          success: false,
          errors: _defineProperty({}, path, [{
            message: "Schema of first argument must be either: 'array', 'object' or 'record'. Found '".concat(serializedSchema.type, "'"),
            typeError: true
          }])
        };
      }
      if (serializedSchema.type === "record" && typeof src !== "string") {
        return {
          success: false,
          errors: _defineProperty({}, path, [{
            message: "Value of keyOf (record) must be 'string', got '".concat(_typeof(src), "'"),
            typeError: true
          }])
        };
      }
      // We check actual value here, since TypeScript also does this. Literals are used in other types (unions),
      // and there it also makes sense to check the actual string values (i.e. that it is not just a string) since
      // missing one would lead to a runtime error. At least this is what we are thinking currently.
      if (serializedSchema.type === "object") {
        var keys = Object.keys(serializedSchema.items);
        if (!keys.includes(src)) {
          return {
            success: false,
            errors: _defineProperty({}, path, [{
              message: "Value of keyOf (object) must be: ".concat(keys.join(", "), ". Found: ").concat(src),
              typeError: true
            }])
          };
        }
      }
      return {
        success: true,
        data: src
      };
    }
  }, {
    key: "nullable",
    value: function nullable() {
      return new KeyOfSchema(this.schema, this.sourcePath, true);
    }
  }, {
    key: "serialize",
    value: function serialize() {
      var path = this.sourcePath;
      if (!path) {
        throw new Error("Cannot serialize keyOf schema with empty selector. TIP: keyOf must be used with a Val Module of record schema.");
      }
      var serializedSchema = this.schema;
      if (!serializedSchema) {
        throw new Error("Cannot serialize keyOf schema with empty selector.");
      }
      var values;
      switch (serializedSchema.type) {
        case "record":
          values = "string";
          break;
        case "object":
          values = Object.keys(serializedSchema.items);
          break;
        default:
          throw new Error("Cannot serialize keyOf schema with selector of type '".concat(serializedSchema.type, "'. keyOf must be used with a Val Module."));
      }
      return {
        type: "keyOf",
        path: path,
        schema: serializedSchema,
        opt: this.opt,
        values: values
      };
    }
  }]);
}(Schema);
var keyOf = function keyOf(valModule) {
  var _valModule$GetSchema;
  return new KeyOfSchema(valModule === null || valModule === void 0 || (_valModule$GetSchema = valModule[GetSchema$1]) === null || _valModule$GetSchema === void 0 ? void 0 : _valModule$GetSchema.serialize(), getValPath(valModule));
};

var DateSchema = /*#__PURE__*/function (_Schema) {
  function DateSchema(options) {
    var _this;
    var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    _classCallCheck(this, DateSchema);
    _this = _callSuper(this, DateSchema);
    _this.options = options;
    _this.opt = opt;
    return _this;
  }
  _inherits(DateSchema, _Schema);
  return _createClass(DateSchema, [{
    key: "validate",
    value: function validate(path, src) {
      var _this$options, _this$options2, _this$options3, _this$options4;
      if (this.opt && (src === null || src === undefined)) {
        return false;
      }
      if (typeof src !== "string") {
        return _defineProperty({}, path, [{
          message: "Expected 'string', got '".concat(_typeof(src), "'"),
          value: src
        }]);
      }
      if ((_this$options = this.options) !== null && _this$options !== void 0 && _this$options.from && (_this$options2 = this.options) !== null && _this$options2 !== void 0 && _this$options2.to) {
        if (this.options.from > this.options.to) {
          return _defineProperty({}, path, [{
            message: "From date ".concat(this.options.from, " is after to date ").concat(this.options.to),
            value: src,
            typeError: true
          }]);
        }
        if (src < this.options.from || src > this.options.to) {
          return _defineProperty({}, path, [{
            message: "Date is not between ".concat(this.options.from, " and ").concat(this.options.to),
            value: src
          }]);
        }
      } else if ((_this$options3 = this.options) !== null && _this$options3 !== void 0 && _this$options3.from) {
        if (src < this.options.from) {
          return _defineProperty({}, path, [{
            message: "Date is before the minimum date ".concat(this.options.from),
            value: src
          }]);
        }
      } else if ((_this$options4 = this.options) !== null && _this$options4 !== void 0 && _this$options4.to) {
        if (src > this.options.to) {
          return _defineProperty({}, path, [{
            message: "Date is after the maximum date ".concat(this.options.to),
            value: src
          }]);
        }
      }
      // const errors = [];

      // if (errors.length > 0) {
      //   return {
      //     [path]: errors,
      //   } as ValidationErrors;
      // }
      return false;
    }
  }, {
    key: "assert",
    value: function assert(path, src) {
      if (this.opt && src === null) {
        return {
          success: true,
          data: src
        };
      }
      if (src === null) {
        return {
          success: false,
          errors: _defineProperty({}, path, [{
            message: "Expected 'string', got 'null'",
            typeError: true
          }])
        };
      }
      if (typeof src !== "string") {
        return {
          success: false,
          errors: _defineProperty({}, path, [{
            message: "Expected 'string', got '".concat(_typeof(src), "'"),
            typeError: true
          }])
        };
      }
      return {
        success: true,
        data: src
      };
    }
  }, {
    key: "from",
    value: function from(_from) {
      return new DateSchema(_objectSpread2(_objectSpread2({}, this.options), {}, {
        from: _from
      }), this.opt);
    }
  }, {
    key: "to",
    value: function to(_to) {
      return new DateSchema(_objectSpread2(_objectSpread2({}, this.options), {}, {
        to: _to
      }), this.opt);
    }
  }, {
    key: "nullable",
    value: function nullable() {
      return new DateSchema(this.options, true);
    }
  }, {
    key: "serialize",
    value: function serialize() {
      return {
        type: "date",
        opt: this.opt,
        options: this.options
      };
    }
  }]);
}(Schema);
var date = function date(options) {
  return new DateSchema(options);
};

// import type { F } from "ts-toolbelt";
// import { i18n, I18n } from "./schema/future/i18n";
// import { oneOf } from "./schema/future/oneOf";

// export type InitSchemaLocalized<Locales extends readonly string[]> = {
//   readonly i18n: I18n<Locales>;
// };
function initSchema() {
  // locales: F.Narrow<Locales>
  return {
    string: string,
    "boolean": _boolean,
    array: array,
    object: object,
    number: number,
    union: union,
    // oneOf,
    richtext: richtext,
    image: image,
    literal: literal,
    keyOf: keyOf,
    record: record,
    file: file,
    date: date
    // i18n: i18n(locales),
  };
}

/**
 * A image source represents the path to a (local) image.
 *
 */

var initImage = function initImage(config) {
  var _config$files$directo, _config$files;
  (_config$files$directo = config === null || config === void 0 || (_config$files = config.files) === null || _config$files === void 0 ? void 0 : _config$files.directory) !== null && _config$files$directo !== void 0 ? _config$files$directo : "/public/val";

  /**
   * Define the source of an image file.
   *
   * @example
   * c.image("/public/val/example.png", {
   *   width: 944,
   *   height: 944,
   *   mimeType: "image/png",
   *})
   *
   * @param ref /public/val/example.png
   * @param metadata Image metadata: width, height, mimeType and optionally a hotspot.
   */

  /**
   * Define the source of an image file.
   *
   * NOTE: this will **not** validate since metadata has not been defined.
   *
   * Run `npx -p @valbuild/cli val validate --fix` to automatically add metadata.
   *
   * @example
   * c.image("/public/val/example.png")
   *
   * @param ref /public/val/example.png
   * @param metadata Image metadata: width, height, mimeType and optionally a hotspot.
   */

  /**
   * Define the source of an image file.
   *
   * @example
   * c.image("/public/val/example.png", {
   *   width: 944,
   *   height: 944,
   *   mimeType: "image/png",
   *})
   *
   * @param ref /public/val/example.png
   * @param metadata Image metadata: width, height, mimeType and optionally a hotspot.
   */
  function image(ref, metadata) {
    return _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, FILE_REF_PROP, ref), VAL_EXTENSION, "file"), FILE_REF_SUBTYPE_TAG, "image"), "metadata", metadata);
  }
  return image;
};

/* eslint-disable @typescript-eslint/ban-types */
// import { i18n, I18n } from "./source/future/i18n";
// import { remote } from "./source/future/remote";

// type NarrowStrings<A> =
//   | (A extends [] ? [] : never)
//   | (A extends string ? A : never)
//   | {
//       [K in keyof A]: NarrowStrings<A[K]>;
//     };

// TODO: Rename to createValSystem (only to be used by internal things), we can then export * from '@valbuild/core' in the next package then.
var initVal = function initVal(config) {
  // const locales = options?.locales;
  var s = initSchema();
  // if (locales?.required) {
  //   console.error("Locales / i18n currently not implemented");
  //   return {
  //     val: {
  //       content,
  //       i18n,
  //       remote,
  //       getPath,
  //       file,
  //       richtext,
  //     },
  //     s,
  //     config: {},
  //     // eslint-disable-next-line @typescript-eslint/no-explicit-any
  //   } as any;
  // }
  return {
    val: {
      getPath: getValPath
    },
    c: {
      define: define,
      // remote,
      file: initFile(config),
      image: initImage(config)
    },
    s: s,
    config: config
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  };
};

/**
 * Define the set of modules that can be edited using the Val UI.
 *
 * @example
 * import { modules } from "@valbuild/next";
 * import { config } from "./val.config";
 *
 * export default modules(config, [
 *  { def: () => import("./app/page.val.ts") },
 *  { def: () => import("./app/another/page.val.ts") },
 * ]);
 */
function modules(config, modules) {
  return {
    config: config,
    modules: modules
  };
}

var PatchError = /*#__PURE__*/_createClass(function PatchError(message) {
  _classCallCheck(this, PatchError);
  this.message = message;
});

/**
 * NOTE: MAY mutate the input document.
 */

function derefPath(path) {
  var dereffedPath = [];
  var referencedPath = null;
  var _iterator = _createForOfIteratorHelper(path),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var segment = _step.value;
      if (segment.startsWith("$")) {
        var dereffedSegment = segment.slice(1);
        dereffedPath.push(dereffedSegment);
        referencedPath = [];
        var _iterator2 = _createForOfIteratorHelper(path.slice(dereffedPath.length)),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _segment = _step2.value;
            if (_segment.startsWith("$")) {
              return err(new PatchError("Cannot reference within reference: ".concat(_segment, ". Path: ").concat(path.join("/"))));
            }
            referencedPath.push(_segment);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        break;
      } else {
        dereffedPath.push(segment);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return ok([dereffedPath, referencedPath]);
}
function derefPatch(patch, document, ops) {
  var fileUpdates = {};
  var dereferencedPatch = [];
  var _iterator3 = _createForOfIteratorHelper(patch),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var op = _step3.value;
      if (op.op === "replace") {
        var maybeDerefRes = derefPath(op.path);
        if (isErr(maybeDerefRes)) {
          return maybeDerefRes;
        }
        var _maybeDerefRes$value = _slicedToArray(maybeDerefRes.value, 2),
          dereffedPath = _maybeDerefRes$value[0],
          referencedPath = _maybeDerefRes$value[1];
        if (referencedPath) {
          var maybeValue = ops.get(document, dereffedPath);
          if (isOk(maybeValue)) {
            var value = maybeValue.value;
            if (isFile(value)) {
              if (referencedPath.length > 0) {
                return err(new PatchError("Cannot sub-reference file reference at path: ".concat(dereffedPath.join("/"))));
              }
              if (typeof op.value !== "string") {
                return err(new PatchError("Expected base64 encoded string value for file reference, got ".concat(JSON.stringify(op.value))));
              }
              fileUpdates[value[FILE_REF_PROP]] = op.value;
              // } else if (isRemote(value)) {
              //   if (!remotePatches[value[REMOTE_REF_PROP]]) {
              //     remotePatches[value[REMOTE_REF_PROP]] = [];
              //   }
              //   remotePatches[value[REMOTE_REF_PROP]].push({
              //     op: "replace",
              //     path: referencedPath,
              //     value: op.value,
              //   });
            } else {
              return err(new PatchError("Unknown reference: ".concat(JSON.stringify(op), " at path: ").concat(dereffedPath.join("/"))));
            }
          } else {
            return maybeValue;
          }
        } else {
          dereferencedPatch.push(op);
        }
      } else if (op.op === "file") {
        if (!op.filePath.startsWith("/public")) {
          return err(new PatchError("Path must start with /public"));
        }
        if (typeof op.value !== "string") {
          return err(new PatchError("File operation must have a value that is typeof string. Found: ".concat(_typeof(op.value))));
        }
        fileUpdates[op.filePath] = op.value;
      } else {
        var _maybeDerefRes = derefPath(op.path);
        if (isErr(_maybeDerefRes)) {
          return _maybeDerefRes;
        }
        var _maybeDerefRes$value2 = _slicedToArray(_maybeDerefRes.value, 2),
          _referencedPath = _maybeDerefRes$value2[1];
        if (_referencedPath) {
          throw new Error("Unimplemented operation: ".concat(JSON.stringify(op)));
        }
        dereferencedPatch.push(op);
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return ok({
    fileUpdates: fileUpdates,
    dereferencedPatch: dereferencedPatch
  });
}

function getVal(selector) {
  return newValProxy(serializedValOfSelectorSource(selector));
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isArrayOrArraySelector(child) {
  if (isSelector$1(child)) {
    return _typeof(child[GetSource]) === "object" && child[GetSource] !== null && Array.isArray(child[GetSource]);
  }
  return Array.isArray(child);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isObjectOrObjectSelector(child) {
  if (isSelector$1(child)) {
    return _typeof(child[GetSource]) === "object" && child[GetSource] !== null && !Array.isArray(child[GetSource]);
  }
  return _typeof(child) === "object";
}
function serializedValOfSelectorSource(selector) {
  var wrappedSelector = newSelectorProxy$1(selector); // NOTE: we do this if call-site uses a literal with selectors inside
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function rec(child) {
    var isArray = isArrayOrArraySelector(child);
    var isObject = isObjectOrObjectSelector(child);
    if (isArray) {
      var array = GetSource in child ? child[GetSource] : child;
      var valPath = Path$1 in child ? child[Path$1] : undefined;
      return {
        val: array.map(function (item, i) {
          return rec(isSelector$1(item) // NOTE: We do this since selectors currently do not create selectors of items unless specifically required.
          ? item : newSelectorProxy$1(item, createValPathOfItem(valPath, i)));
        }),
        valPath: valPath
      };
    } else if (isObject) {
      var obj = GetSource in child ? child[GetSource] : child;
      var _valPath = Path$1 in child ? child[Path$1] : undefined;
      return {
        val: obj !== null && Object.fromEntries(Object.entries(obj).map(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];
          return [key, rec(isSelector$1(value) // NOTE: We do this since selectors currently do not create selectors of items unless specifically required.
          ? value : newSelectorProxy$1(value, createValPathOfItem(_valPath, key)))];
        })),
        valPath: _valPath
      };
    } else if (isSelector$1(child)) {
      return {
        val: rec(child[GetSource]),
        valPath: child[Path$1]
      };
    } else {
      return child;
    }
  }
  return rec(wrappedSelector);
}
function strip(value) {
  var val = isSerializedVal(value) ? value.val : value;
  switch (_typeof(val)) {
    case "function":
    case "symbol":
      throw Error("Invalid val type: ".concat(_typeof(val)));
    case "object":
      if (val === null) {
        return null;
      } else if (Array.isArray(val)) {
        return val.map(strip);
      } else {
        return Object.fromEntries(Object.entries(val).map(function (_ref3) {
          var _ref4 = _slicedToArray(_ref3, 2),
            key = _ref4[0],
            value = _ref4[1];
          return [key, value && strip(value)];
        }));
      }
    // intentional fallthrough
    // eslint-disable-next-line no-fallthrough
    default:
      return val;
  }
}
function newValProxy(val) {
  var source = val.val;
  switch (_typeof(source)) {
    case "function":
    case "symbol":
      throw Error("Invalid val type: ".concat(_typeof(source)));
    case "object":
      if (source !== null) {
        // Handles both objects and arrays!
        return new Proxy(source, {
          has: function has(target, prop) {
            if (prop === "val") {
              return true;
            }
            if (prop === Path$1) {
              return true;
            }
            return hasOwn(target, prop);
          },
          get: function get(target, prop) {
            if (prop === Path$1) {
              return val.valPath;
            }
            if (prop === "val") {
              return strip(val);
            }
            if (Array.isArray(target) && prop === "length") {
              return target.length;
            }
            if (hasOwn(source, prop)) {
              var _Reflect$get$valPath, _Reflect$get;
              return newValProxy({
                val: Reflect.get(target, prop).val,
                valPath: (_Reflect$get$valPath = (_Reflect$get = Reflect.get(target, prop)) === null || _Reflect$get === void 0 ? void 0 : _Reflect$get.valPath) !== null && _Reflect$get$valPath !== void 0 ? _Reflect$get$valPath : createValPathOfItem(val.valPath, Array.isArray(target) ? Number(prop) : prop)
              });
            }
            return Reflect.get(target, prop);
          }
        });
      }
    // intentional fallthrough
    // eslint-disable-next-line no-fallthrough
    default:
      return _defineProperty(_defineProperty({}, Path$1, val.valPath), "val", val.val);
  }
}
function hasOwn(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

/**
 * From: https://github.com/kawanet/sha256-uint8array/commit/a035f83824c319d01ca1e7559fdcf1632c0cd6c4
 *
 * LICENSE:
 *
 * MIT License
 * Copyright (c) 2020-2023 Yusuke Kawasaki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 * sha256-uint8array.ts
 */

// first 32 bits of the fractional parts of the cube roots of the first 64 primes 2..311
var K = [0x428a2f98 | 0, 0x71374491 | 0, 0xb5c0fbcf | 0, 0xe9b5dba5 | 0, 0x3956c25b | 0, 0x59f111f1 | 0, 0x923f82a4 | 0, 0xab1c5ed5 | 0, 0xd807aa98 | 0, 0x12835b01 | 0, 0x243185be | 0, 0x550c7dc3 | 0, 0x72be5d74 | 0, 0x80deb1fe | 0, 0x9bdc06a7 | 0, 0xc19bf174 | 0, 0xe49b69c1 | 0, 0xefbe4786 | 0, 0x0fc19dc6 | 0, 0x240ca1cc | 0, 0x2de92c6f | 0, 0x4a7484aa | 0, 0x5cb0a9dc | 0, 0x76f988da | 0, 0x983e5152 | 0, 0xa831c66d | 0, 0xb00327c8 | 0, 0xbf597fc7 | 0, 0xc6e00bf3 | 0, 0xd5a79147 | 0, 0x06ca6351 | 0, 0x14292967 | 0, 0x27b70a85 | 0, 0x2e1b2138 | 0, 0x4d2c6dfc | 0, 0x53380d13 | 0, 0x650a7354 | 0, 0x766a0abb | 0, 0x81c2c92e | 0, 0x92722c85 | 0, 0xa2bfe8a1 | 0, 0xa81a664b | 0, 0xc24b8b70 | 0, 0xc76c51a3 | 0, 0xd192e819 | 0, 0xd6990624 | 0, 0xf40e3585 | 0, 0x106aa070 | 0, 0x19a4c116 | 0, 0x1e376c08 | 0, 0x2748774c | 0, 0x34b0bcb5 | 0, 0x391c0cb3 | 0, 0x4ed8aa4a | 0, 0x5b9cca4f | 0, 0x682e6ff3 | 0, 0x748f82ee | 0, 0x78a5636f | 0, 0x84c87814 | 0, 0x8cc70208 | 0, 0x90befffa | 0, 0xa4506ceb | 0, 0xbef9a3f7 | 0, 0xc67178f2 | 0];
var N = /*#__PURE__*/function (N) {
  N[N["inputBytes"] = 64] = "inputBytes";
  N[N["inputWords"] = 16] = "inputWords";
  N[N["highIndex"] = 14] = "highIndex";
  N[N["lowIndex"] = 15] = "lowIndex";
  N[N["workWords"] = 64] = "workWords";
  N[N["allocBytes"] = 80] = "allocBytes";
  N[N["allocWords"] = 20] = "allocWords";
  N[N["allocTotal"] = 8000] = "allocTotal";
  return N;
}(N || {});
var algorithms = {
  sha256: 1
};
function createHash(algorithm) {
  if (algorithm && !algorithms[algorithm] && !algorithms[algorithm.toLowerCase()]) {
    throw new Error("Digest method not supported");
  }
  return new Hash();
}
var Hash = /*#__PURE__*/function () {
  // surrogate pair

  function Hash() {
    _classCallCheck(this, Hash);
    // first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19
    _defineProperty(this, "A", 0x6a09e667 | 0);
    _defineProperty(this, "B", 0xbb67ae85 | 0);
    _defineProperty(this, "C", 0x3c6ef372 | 0);
    _defineProperty(this, "D", 0xa54ff53a | 0);
    _defineProperty(this, "E", 0x510e527f | 0);
    _defineProperty(this, "F", 0x9b05688c | 0);
    _defineProperty(this, "G", 0x1f83d9ab | 0);
    _defineProperty(this, "H", 0x5be0cd19 | 0);
    _defineProperty(this, "_size", 0);
    _defineProperty(this, "_sp", 0);
    if (!sharedBuffer || sharedOffset >= N.allocTotal) {
      sharedBuffer = new ArrayBuffer(N.allocTotal);
      sharedOffset = 0;
    }
    this._byte = new Uint8Array(sharedBuffer, sharedOffset, N.allocBytes);
    this._word = new Int32Array(sharedBuffer, sharedOffset, N.allocWords);
    sharedOffset += N.allocBytes;
  }
  return _createClass(Hash, [{
    key: "update",
    value: function update(data) {
      // data: string
      if ("string" === typeof data) {
        return this._utf8(data);
      }

      // data: undefined
      if (data == null) {
        throw new TypeError("Invalid type: " + _typeof(data));
      }
      var byteOffset = data.byteOffset;
      var length = data.byteLength;
      var blocks = length / N.inputBytes | 0;
      var offset = 0;

      // longer than 1 block
      if (blocks && !(byteOffset & 3) && !(this._size % N.inputBytes)) {
        var block = new Int32Array(data.buffer, byteOffset, blocks * N.inputWords);
        while (blocks--) {
          this._int32(block, offset >> 2);
          offset += N.inputBytes;
        }
        this._size += offset;
      }

      // data: TypedArray | DataView
      var BYTES_PER_ELEMENT = data.BYTES_PER_ELEMENT;
      if (BYTES_PER_ELEMENT !== 1 && data.buffer) {
        var rest = new Uint8Array(data.buffer, byteOffset + offset, length - offset);
        return this._uint8(rest);
      }

      // no more bytes
      if (offset === length) return this;

      // data: Uint8Array | Int8Array
      return this._uint8(data, offset);
    }
  }, {
    key: "_uint8",
    value: function _uint8(data, offset) {
      var _byte = this._byte,
        _word = this._word;
      var length = data.length;
      offset = offset | 0;
      while (offset < length) {
        var start = this._size % N.inputBytes;
        var index = start;
        while (offset < length && index < N.inputBytes) {
          _byte[index++] = data[offset++];
        }
        if (index >= N.inputBytes) {
          this._int32(_word);
        }
        this._size += index - start;
      }
      return this;
    }
  }, {
    key: "_utf8",
    value: function _utf8(text) {
      var _byte = this._byte,
        _word = this._word;
      var length = text.length;
      var surrogate = this._sp;
      for (var offset = 0; offset < length;) {
        var start = this._size % N.inputBytes;
        var index = start;
        while (offset < length && index < N.inputBytes) {
          var code = text.charCodeAt(offset++) | 0;
          if (code < 0x80) {
            // ASCII characters
            _byte[index++] = code;
          } else if (code < 0x800) {
            // 2 bytes
            _byte[index++] = 0xc0 | code >>> 6;
            _byte[index++] = 0x80 | code & 0x3f;
          } else if (code < 0xd800 || code > 0xdfff) {
            // 3 bytes
            _byte[index++] = 0xe0 | code >>> 12;
            _byte[index++] = 0x80 | code >>> 6 & 0x3f;
            _byte[index++] = 0x80 | code & 0x3f;
          } else if (surrogate) {
            // 4 bytes - surrogate pair
            code = ((surrogate & 0x3ff) << 10) + (code & 0x3ff) + 0x10000;
            _byte[index++] = 0xf0 | code >>> 18;
            _byte[index++] = 0x80 | code >>> 12 & 0x3f;
            _byte[index++] = 0x80 | code >>> 6 & 0x3f;
            _byte[index++] = 0x80 | code & 0x3f;
            surrogate = 0;
          } else {
            surrogate = code;
          }
        }
        if (index >= N.inputBytes) {
          this._int32(_word);
          _word[0] = _word[N.inputWords];
        }
        this._size += index - start;
      }
      this._sp = surrogate;
      return this;
    }
  }, {
    key: "_int32",
    value: function _int32(data, offset) {
      var A = this.A,
        B = this.B,
        C = this.C,
        D = this.D,
        E = this.E,
        F = this.F,
        G = this.G,
        H = this.H;
      var i = 0;
      offset = offset | 0;
      while (i < N.inputWords) {
        W[i++] = swap32(data[offset++]);
      }
      for (i = N.inputWords; i < N.workWords; i++) {
        W[i] = gamma1(W[i - 2]) + W[i - 7] + gamma0(W[i - 15]) + W[i - 16] | 0;
      }
      for (i = 0; i < N.workWords; i++) {
        var T1 = H + sigma1(E) + ch(E, F, G) + K[i] + W[i] | 0;
        var T2 = sigma0(A) + maj(A, B, C) | 0;
        H = G;
        G = F;
        F = E;
        E = D + T1 | 0;
        D = C;
        C = B;
        B = A;
        A = T1 + T2 | 0;
      }
      this.A = A + this.A | 0;
      this.B = B + this.B | 0;
      this.C = C + this.C | 0;
      this.D = D + this.D | 0;
      this.E = E + this.E | 0;
      this.F = F + this.F | 0;
      this.G = G + this.G | 0;
      this.H = H + this.H | 0;
    }
  }, {
    key: "digest",
    value: function digest(encoding) {
      var _byte = this._byte,
        _word = this._word;
      var i = this._size % N.inputBytes | 0;
      _byte[i++] = 0x80;

      // pad 0 for current word
      while (i & 3) {
        _byte[i++] = 0;
      }
      i >>= 2;
      if (i > N.highIndex) {
        while (i < N.inputWords) {
          _word[i++] = 0;
        }
        i = 0;
        this._int32(_word);
      }

      // pad 0 for rest words
      while (i < N.inputWords) {
        _word[i++] = 0;
      }

      // input size
      var bits64 = this._size * 8;
      var low32 = (bits64 & 0xffffffff) >>> 0;
      var high32 = (bits64 - low32) / 0x100000000;
      if (high32) _word[N.highIndex] = swap32(high32);
      if (low32) _word[N.lowIndex] = swap32(low32);
      this._int32(_word);
      return encoding === "hex" ? this._hex() : this._bin();
    }
  }, {
    key: "_hex",
    value: function _hex() {
      var A = this.A,
        B = this.B,
        C = this.C,
        D = this.D,
        E = this.E,
        F = this.F,
        G = this.G,
        H = this.H;
      return hex32(A) + hex32(B) + hex32(C) + hex32(D) + hex32(E) + hex32(F) + hex32(G) + hex32(H);
    }
  }, {
    key: "_bin",
    value: function _bin() {
      var A = this.A,
        B = this.B,
        C = this.C,
        D = this.D,
        E = this.E,
        F = this.F,
        G = this.G,
        H = this.H,
        _byte = this._byte,
        _word = this._word;
      _word[0] = swap32(A);
      _word[1] = swap32(B);
      _word[2] = swap32(C);
      _word[3] = swap32(D);
      _word[4] = swap32(E);
      _word[5] = swap32(F);
      _word[6] = swap32(G);
      _word[7] = swap32(H);
      return _byte.slice(0, 32);
    }
  }]);
}();
var W = new Int32Array(N.workWords);
var sharedBuffer;
var sharedOffset = 0;
var hex32 = function hex32(num) {
  return (num + 0x100000000).toString(16).substr(-8);
};
var swapLE = function swapLE(c) {
  return c << 24 & 0xff000000 | c << 8 & 0xff0000 | c >> 8 & 0xff00 | c >> 24 & 0xff;
};
var swapBE = function swapBE(c) {
  return c;
};
var swap32 = isBE() ? swapBE : swapLE;
var ch = function ch(x, y, z) {
  return z ^ x & (y ^ z);
};
var maj = function maj(x, y, z) {
  return x & y | z & (x | y);
};
var sigma0 = function sigma0(x) {
  return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
};
var sigma1 = function sigma1(x) {
  return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
};
var gamma0 = function gamma0(x) {
  return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
};
var gamma1 = function gamma1(x) {
  return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
};
function isBE() {
  var buf = new Uint8Array(new Uint16Array([0xfeff]).buffer); // BOM
  return buf[0] === 0xfe;
}
var getSHA256Hash = function getSHA256Hash(bits) {
  return createHash().update(bits).digest("hex");
};

var EXT_TO_MIME_TYPES = {
  x3d: "application/vnd.hzn-3d-crossword",
  "3gp": "video/3gpp",
  "3g2": "video/3gpp2",
  mseq: "application/vnd.mseq",
  pwn: "application/vnd.3m.post-it-notes",
  plb: "application/vnd.3gpp.pic-bw-large",
  psb: "application/vnd.3gpp.pic-bw-small",
  pvb: "application/vnd.3gpp.pic-bw-var",
  tcap: "application/vnd.3gpp2.tcap",
  "7z": "application/x-7z-compressed",
  abw: "application/x-abiword",
  ace: "application/x-ace-compressed",
  acc: "application/vnd.americandynamics.acc",
  acu: "application/vnd.acucobol",
  atc: "application/vnd.acucorp",
  adp: "audio/adpcm",
  aab: "application/x-authorware-bin",
  aam: "application/x-authorware-map",
  aas: "application/x-authorware-seg",
  air: "application/vnd.adobe.air-application-installer-package+zip",
  swf: "application/x-shockwave-flash",
  fxp: "application/vnd.adobe.fxp",
  pdf: "application/pdf",
  ppd: "application/vnd.cups-ppd",
  dir: "application/x-director",
  xdp: "application/vnd.adobe.xdp+xml",
  xfdf: "application/vnd.adobe.xfdf",
  aac: "audio/x-aac",
  ahead: "application/vnd.ahead.space",
  azf: "application/vnd.airzip.filesecure.azf",
  azs: "application/vnd.airzip.filesecure.azs",
  azw: "application/vnd.amazon.ebook",
  ami: "application/vnd.amiga.ami",
  "N/A": "application/andrew-inset",
  apk: "application/vnd.android.package-archive",
  cii: "application/vnd.anser-web-certificate-issue-initiation",
  fti: "application/vnd.anser-web-funds-transfer-initiation",
  atx: "application/vnd.antix.game-component",
  dmg: "application/x-apple-diskimage",
  mpkg: "application/vnd.apple.installer+xml",
  aw: "application/applixware",
  mp3: "audio/mpeg",
  les: "application/vnd.hhe.lesson-player",
  swi: "application/vnd.aristanetworks.swi",
  s: "text/x-asm",
  atomcat: "application/atomcat+xml",
  atomsvc: "application/atomsvc+xml",
  atom: "application/atom+xml",
  ac: "application/pkix-attr-cert",
  aif: "audio/x-aiff",
  avi: "video/x-msvideo",
  aep: "application/vnd.audiograph",
  dxf: "image/vnd.dxf",
  dwf: "model/vnd.dwf",
  par: "text/plain-bas",
  bcpio: "application/x-bcpio",
  bin: "application/octet-stream",
  bmp: "image/bmp",
  torrent: "application/x-bittorrent",
  cod: "application/vnd.rim.cod",
  mpm: "application/vnd.blueice.multipass",
  bmi: "application/vnd.bmi",
  sh: "application/x-sh",
  btif: "image/prs.btif",
  rep: "application/vnd.businessobjects",
  bz: "application/x-bzip",
  bz2: "application/x-bzip2",
  csh: "application/x-csh",
  c: "text/x-c",
  cdxml: "application/vnd.chemdraw+xml",
  css: "text/css",
  cdx: "chemical/x-cdx",
  cml: "chemical/x-cml",
  csml: "chemical/x-csml",
  cdbcmsg: "application/vnd.contact.cmsg",
  cla: "application/vnd.claymore",
  c4g: "application/vnd.clonk.c4group",
  sub: "image/vnd.dvb.subtitle",
  cdmia: "application/cdmi-capability",
  cdmic: "application/cdmi-container",
  cdmid: "application/cdmi-domain",
  cdmio: "application/cdmi-object",
  cdmiq: "application/cdmi-queue",
  c11amc: "application/vnd.cluetrust.cartomobile-config",
  c11amz: "application/vnd.cluetrust.cartomobile-config-pkg",
  ras: "image/x-cmu-raster",
  dae: "model/vnd.collada+xml",
  csv: "text/csv",
  cpt: "application/mac-compactpro",
  wmlc: "application/vnd.wap.wmlc",
  cgm: "image/cgm",
  ice: "x-conference/x-cooltalk",
  cmx: "image/x-cmx",
  xar: "application/vnd.xara",
  cmc: "application/vnd.cosmocaller",
  cpio: "application/x-cpio",
  clkx: "application/vnd.crick.clicker",
  clkk: "application/vnd.crick.clicker.keyboard",
  clkp: "application/vnd.crick.clicker.palette",
  clkt: "application/vnd.crick.clicker.template",
  clkw: "application/vnd.crick.clicker.wordbank",
  wbs: "application/vnd.criticaltools.wbs+xml",
  cryptonote: "application/vnd.rig.cryptonote",
  cif: "chemical/x-cif",
  cmdf: "chemical/x-cmdf",
  cu: "application/cu-seeme",
  cww: "application/prs.cww",
  curl: "text/vnd.curl",
  dcurl: "text/vnd.curl.dcurl",
  mcurl: "text/vnd.curl.mcurl",
  scurl: "text/vnd.curl.scurl",
  car: "application/vnd.curl.car",
  pcurl: "application/vnd.curl.pcurl",
  cmp: "application/vnd.yellowriver-custom-menu",
  dssc: "application/dssc+der",
  xdssc: "application/dssc+xml",
  deb: "application/x-debian-package",
  uva: "audio/vnd.dece.audio",
  uvi: "image/vnd.dece.graphic",
  uvh: "video/vnd.dece.hd",
  uvm: "video/vnd.dece.mobile",
  uvu: "video/vnd.uvvu.mp4",
  uvp: "video/vnd.dece.pd",
  uvs: "video/vnd.dece.sd",
  uvv: "video/vnd.dece.video",
  dvi: "application/x-dvi",
  seed: "application/vnd.fdsn.seed",
  dtb: "application/x-dtbook+xml",
  res: "application/x-dtbresource+xml",
  ait: "application/vnd.dvb.ait",
  svc: "application/vnd.dvb.service",
  eol: "audio/vnd.digital-winds",
  djvu: "image/vnd.djvu",
  dtd: "application/xml-dtd",
  mlp: "application/vnd.dolby.mlp",
  wad: "application/x-doom",
  dpg: "application/vnd.dpgraph",
  dra: "audio/vnd.dra",
  dfac: "application/vnd.dreamfactory",
  dts: "audio/vnd.dts",
  dtshd: "audio/vnd.dts.hd",
  dwg: "image/vnd.dwg",
  geo: "application/vnd.dynageo",
  es: "application/ecmascript",
  mag: "application/vnd.ecowin.chart",
  mmr: "image/vnd.fujixerox.edmics-mmr",
  rlc: "image/vnd.fujixerox.edmics-rlc",
  exi: "application/exi",
  mgz: "application/vnd.proteus.magazine",
  epub: "application/epub+zip",
  eml: "message/rfc822",
  nml: "application/vnd.enliven",
  xpr: "application/vnd.is-xpr",
  xif: "image/vnd.xiff",
  xfdl: "application/vnd.xfdl",
  emma: "application/emma+xml",
  ez2: "application/vnd.ezpix-album",
  ez3: "application/vnd.ezpix-package",
  fst: "image/vnd.fst",
  fvt: "video/vnd.fvt",
  fbs: "image/vnd.fastbidsheet",
  fe_launch: "application/vnd.denovo.fcselayout-link",
  f4v: "video/x-f4v",
  flv: "video/x-flv",
  fpx: "image/vnd.fpx",
  npx: "image/vnd.net-fpx",
  flx: "text/vnd.fmi.flexstor",
  fli: "video/x-fli",
  ftc: "application/vnd.fluxtime.clip",
  fdf: "application/vnd.fdf",
  f: "text/x-fortran",
  mif: "application/vnd.mif",
  fm: "application/vnd.framemaker",
  fh: "image/x-freehand",
  fsc: "application/vnd.fsc.weblaunch",
  fnc: "application/vnd.frogans.fnc",
  ltf: "application/vnd.frogans.ltf",
  ddd: "application/vnd.fujixerox.ddd",
  xdw: "application/vnd.fujixerox.docuworks",
  xbd: "application/vnd.fujixerox.docuworks.binder",
  oas: "application/vnd.fujitsu.oasys",
  oa2: "application/vnd.fujitsu.oasys2",
  oa3: "application/vnd.fujitsu.oasys3",
  fg5: "application/vnd.fujitsu.oasysgp",
  bh2: "application/vnd.fujitsu.oasysprs",
  spl: "application/x-futuresplash",
  fzs: "application/vnd.fuzzysheet",
  g3: "image/g3fax",
  gmx: "application/vnd.gmx",
  gtw: "model/vnd.gtw",
  txd: "application/vnd.genomatix.tuxedo",
  ggb: "application/vnd.geogebra.file",
  ggt: "application/vnd.geogebra.tool",
  gdl: "model/vnd.gdl",
  gex: "application/vnd.geometry-explorer",
  gxt: "application/vnd.geonext",
  g2w: "application/vnd.geoplan",
  g3w: "application/vnd.geospace",
  gsf: "application/x-font-ghostscript",
  bdf: "application/x-font-bdf",
  gtar: "application/x-gtar",
  texinfo: "application/x-texinfo",
  gnumeric: "application/x-gnumeric",
  kml: "application/vnd.google-earth.kml+xml",
  kmz: "application/vnd.google-earth.kmz",
  gqf: "application/vnd.grafeq",
  gif: "image/gif",
  gv: "text/vnd.graphviz",
  gac: "application/vnd.groove-account",
  ghf: "application/vnd.groove-help",
  gim: "application/vnd.groove-identity-message",
  grv: "application/vnd.groove-injector",
  gtm: "application/vnd.groove-tool-message",
  tpl: "application/vnd.groove-tool-template",
  vcg: "application/vnd.groove-vcard",
  h261: "video/h261",
  h263: "video/h263",
  h264: "video/h264",
  hpid: "application/vnd.hp-hpid",
  hps: "application/vnd.hp-hps",
  hdf: "application/x-hdf",
  rip: "audio/vnd.rip",
  hbci: "application/vnd.hbci",
  jlt: "application/vnd.hp-jlyt",
  pcl: "application/vnd.hp-pcl",
  hpgl: "application/vnd.hp-hpgl",
  hvs: "application/vnd.yamaha.hv-script",
  hvd: "application/vnd.yamaha.hv-dic",
  hvp: "application/vnd.yamaha.hv-voice",
  "sfd-hdstx": "application/vnd.hydrostatix.sof-data",
  stk: "application/hyperstudio",
  hal: "application/vnd.hal+xml",
  html: "text/html",
  irm: "application/vnd.ibm.rights-management",
  sc: "application/vnd.ibm.secure-container",
  ics: "text/calendar",
  icc: "application/vnd.iccprofile",
  ico: "image/x-icon",
  igl: "application/vnd.igloader",
  ief: "image/ief",
  ivp: "application/vnd.immervision-ivp",
  ivu: "application/vnd.immervision-ivu",
  rif: "application/reginfo+xml",
  "3dml": "text/vnd.in3d.3dml",
  spot: "text/vnd.in3d.spot",
  igs: "model/iges",
  i2g: "application/vnd.intergeo",
  cdy: "application/vnd.cinderella",
  xpw: "application/vnd.intercon.formnet",
  fcs: "application/vnd.isac.fcs",
  ipfix: "application/ipfix",
  cer: "application/pkix-cert",
  pki: "application/pkixcmp",
  crl: "application/pkix-crl",
  pkipath: "application/pkix-pkipath",
  igm: "application/vnd.insors.igm",
  rcprofile: "application/vnd.ipunplugged.rcprofile",
  irp: "application/vnd.irepository.package+xml",
  jad: "text/vnd.sun.j2me.app-descriptor",
  jar: "application/java-archive",
  "class": "application/java-vm",
  jnlp: "application/x-java-jnlp-file",
  ser: "application/java-serialized-object",
  java: "text/x-java-source,java",
  js: "application/javascript",
  json: "application/json",
  joda: "application/vnd.joost.joda-archive",
  jpm: "video/jpm",
  jpeg: "image/jpeg",
  jpg: "image/jpeg",
  pjpeg: "image/pjpeg",
  jpgv: "video/jpeg",
  ktz: "application/vnd.kahootz",
  mmd: "application/vnd.chipnuts.karaoke-mmd",
  karbon: "application/vnd.kde.karbon",
  chrt: "application/vnd.kde.kchart",
  kfo: "application/vnd.kde.kformula",
  flw: "application/vnd.kde.kivio",
  kon: "application/vnd.kde.kontour",
  kpr: "application/vnd.kde.kpresenter",
  ksp: "application/vnd.kde.kspread",
  kwd: "application/vnd.kde.kword",
  htke: "application/vnd.kenameaapp",
  kia: "application/vnd.kidspiration",
  kne: "application/vnd.kinar",
  sse: "application/vnd.kodak-descriptor",
  lasxml: "application/vnd.las.las+xml",
  latex: "application/x-latex",
  lbd: "application/vnd.llamagraphics.life-balance.desktop",
  lbe: "application/vnd.llamagraphics.life-balance.exchange+xml",
  jam: "application/vnd.jam",
  "123": "application/vnd.lotus-1-2-3",
  apr: "application/vnd.lotus-approach",
  pre: "application/vnd.lotus-freelance",
  nsf: "application/vnd.lotus-notes",
  org: "application/vnd.lotus-organizer",
  scm: "application/vnd.lotus-screencam",
  lwp: "application/vnd.lotus-wordpro",
  lvp: "audio/vnd.lucent.voice",
  m3u: "audio/x-mpegurl",
  m4v: "video/x-m4v",
  hqx: "application/mac-binhex40",
  portpkg: "application/vnd.macports.portpkg",
  mgp: "application/vnd.osgeo.mapguide.package",
  mrc: "application/marc",
  mrcx: "application/marcxml+xml",
  mxf: "application/mxf",
  nbp: "application/vnd.wolfram.player",
  ma: "application/mathematica",
  mathml: "application/mathml+xml",
  mbox: "application/mbox",
  mc1: "application/vnd.medcalcdata",
  mscml: "application/mediaservercontrol+xml",
  cdkey: "application/vnd.mediastation.cdkey",
  mwf: "application/vnd.mfer",
  mfm: "application/vnd.mfmp",
  msh: "model/mesh",
  mads: "application/mads+xml",
  mets: "application/mets+xml",
  mods: "application/mods+xml",
  meta4: "application/metalink4+xml",
  mcd: "application/vnd.mcd",
  flo: "application/vnd.micrografx.flo",
  igx: "application/vnd.micrografx.igx",
  es3: "application/vnd.eszigno3+xml",
  mdb: "application/x-msaccess",
  asf: "video/x-ms-asf",
  exe: "application/x-msdownload",
  cil: "application/vnd.ms-artgalry",
  cab: "application/vnd.ms-cab-compressed",
  ims: "application/vnd.ms-ims",
  application: "application/x-ms-application",
  clp: "application/x-msclip",
  mdi: "image/vnd.ms-modi",
  eot: "application/vnd.ms-fontobject",
  xls: "application/vnd.ms-excel",
  xlam: "application/vnd.ms-excel.addin.macroenabled.12",
  xlsb: "application/vnd.ms-excel.sheet.binary.macroenabled.12",
  xltm: "application/vnd.ms-excel.template.macroenabled.12",
  xlsm: "application/vnd.ms-excel.sheet.macroenabled.12",
  chm: "application/vnd.ms-htmlhelp",
  crd: "application/x-mscardfile",
  lrm: "application/vnd.ms-lrm",
  mvb: "application/x-msmediaview",
  mny: "application/x-msmoney",
  pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  sldx: "application/vnd.openxmlformats-officedocument.presentationml.slide",
  ppsx: "application/vnd.openxmlformats-officedocument.presentationml.slideshow",
  potx: "application/vnd.openxmlformats-officedocument.presentationml.template",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  dotx: "application/vnd.openxmlformats-officedocument.wordprocessingml.template",
  obd: "application/x-msbinder",
  thmx: "application/vnd.ms-officetheme",
  onetoc: "application/onenote",
  pya: "audio/vnd.ms-playready.media.pya",
  pyv: "video/vnd.ms-playready.media.pyv",
  ppt: "application/vnd.ms-powerpoint",
  ppam: "application/vnd.ms-powerpoint.addin.macroenabled.12",
  sldm: "application/vnd.ms-powerpoint.slide.macroenabled.12",
  pptm: "application/vnd.ms-powerpoint.presentation.macroenabled.12",
  ppsm: "application/vnd.ms-powerpoint.slideshow.macroenabled.12",
  potm: "application/vnd.ms-powerpoint.template.macroenabled.12",
  mpp: "application/vnd.ms-project",
  pub: "application/x-mspublisher",
  scd: "application/x-msschedule",
  xap: "application/x-silverlight-app",
  stl: "application/vnd.ms-pki.stl",
  cat: "application/vnd.ms-pki.seccat",
  vsd: "application/vnd.visio",
  vsdx: "application/vnd.visio2013",
  wm: "video/x-ms-wm",
  wma: "audio/x-ms-wma",
  wax: "audio/x-ms-wax",
  wmx: "video/x-ms-wmx",
  wmd: "application/x-ms-wmd",
  wpl: "application/vnd.ms-wpl",
  wmz: "application/x-ms-wmz",
  wmv: "video/x-ms-wmv",
  wvx: "video/x-ms-wvx",
  wmf: "application/x-msmetafile",
  trm: "application/x-msterminal",
  doc: "application/msword",
  docm: "application/vnd.ms-word.document.macroenabled.12",
  dotm: "application/vnd.ms-word.template.macroenabled.12",
  wri: "application/x-mswrite",
  wps: "application/vnd.ms-works",
  xbap: "application/x-ms-xbap",
  xps: "application/vnd.ms-xpsdocument",
  mid: "audio/midi",
  mpy: "application/vnd.ibm.minipay",
  afp: "application/vnd.ibm.modcap",
  rms: "application/vnd.jcp.javame.midlet-rms",
  tmo: "application/vnd.tmobile-livetv",
  prc: "application/x-mobipocket-ebook",
  mbk: "application/vnd.mobius.mbk",
  dis: "application/vnd.mobius.dis",
  plc: "application/vnd.mobius.plc",
  mqy: "application/vnd.mobius.mqy",
  msl: "application/vnd.mobius.msl",
  txf: "application/vnd.mobius.txf",
  daf: "application/vnd.mobius.daf",
  fly: "text/vnd.fly",
  mpc: "application/vnd.mophun.certificate",
  mpn: "application/vnd.mophun.application",
  mj2: "video/mj2",
  mpga: "audio/mpeg",
  mxu: "video/vnd.mpegurl",
  mpeg: "video/mpeg",
  m21: "application/mp21",
  mp4a: "audio/mp4",
  mp4: "video/mp4",
  m3u8: "application/vnd.apple.mpegurl",
  mus: "application/vnd.musician",
  msty: "application/vnd.muvee.style",
  mxml: "application/xv+xml",
  ngdat: "application/vnd.nokia.n-gage.data",
  "n-gage": "application/vnd.nokia.n-gage.symbian.install",
  ncx: "application/x-dtbncx+xml",
  nc: "application/x-netcdf",
  nlu: "application/vnd.neurolanguage.nlu",
  dna: "application/vnd.dna",
  nnd: "application/vnd.noblenet-directory",
  nns: "application/vnd.noblenet-sealer",
  nnw: "application/vnd.noblenet-web",
  rpst: "application/vnd.nokia.radio-preset",
  rpss: "application/vnd.nokia.radio-presets",
  n3: "text/n3",
  edm: "application/vnd.novadigm.edm",
  edx: "application/vnd.novadigm.edx",
  ext: "application/vnd.novadigm.ext",
  gph: "application/vnd.flographit",
  ecelp4800: "audio/vnd.nuera.ecelp4800",
  ecelp7470: "audio/vnd.nuera.ecelp7470",
  ecelp9600: "audio/vnd.nuera.ecelp9600",
  oda: "application/oda",
  ogx: "application/ogg",
  oga: "audio/ogg",
  ogv: "video/ogg",
  dd2: "application/vnd.oma.dd2+xml",
  oth: "application/vnd.oasis.opendocument.text-web",
  opf: "application/oebps-package+xml",
  qbo: "application/vnd.intu.qbo",
  oxt: "application/vnd.openofficeorg.extension",
  osf: "application/vnd.yamaha.openscoreformat",
  weba: "audio/webm",
  webm: "video/webm",
  odc: "application/vnd.oasis.opendocument.chart",
  otc: "application/vnd.oasis.opendocument.chart-template",
  odb: "application/vnd.oasis.opendocument.database",
  odf: "application/vnd.oasis.opendocument.formula",
  odft: "application/vnd.oasis.opendocument.formula-template",
  odg: "application/vnd.oasis.opendocument.graphics",
  otg: "application/vnd.oasis.opendocument.graphics-template",
  odi: "application/vnd.oasis.opendocument.image",
  oti: "application/vnd.oasis.opendocument.image-template",
  odp: "application/vnd.oasis.opendocument.presentation",
  otp: "application/vnd.oasis.opendocument.presentation-template",
  ods: "application/vnd.oasis.opendocument.spreadsheet",
  ots: "application/vnd.oasis.opendocument.spreadsheet-template",
  odt: "application/vnd.oasis.opendocument.text",
  odm: "application/vnd.oasis.opendocument.text-master",
  ott: "application/vnd.oasis.opendocument.text-template",
  ktx: "image/ktx",
  sxc: "application/vnd.sun.xml.calc",
  stc: "application/vnd.sun.xml.calc.template",
  sxd: "application/vnd.sun.xml.draw",
  std: "application/vnd.sun.xml.draw.template",
  sxi: "application/vnd.sun.xml.impress",
  sti: "application/vnd.sun.xml.impress.template",
  sxm: "application/vnd.sun.xml.math",
  sxw: "application/vnd.sun.xml.writer",
  sxg: "application/vnd.sun.xml.writer.global",
  stw: "application/vnd.sun.xml.writer.template",
  otf: "application/x-font-otf",
  osfpvg: "application/vnd.yamaha.openscoreformat.osfpvg+xml",
  dp: "application/vnd.osgi.dp",
  pdb: "application/vnd.palm",
  p: "text/x-pascal",
  paw: "application/vnd.pawaafile",
  pclxl: "application/vnd.hp-pclxl",
  efif: "application/vnd.picsel",
  pcx: "image/x-pcx",
  psd: "image/vnd.adobe.photoshop",
  prf: "application/pics-rules",
  pic: "image/x-pict",
  chat: "application/x-chat",
  p10: "application/pkcs10",
  p12: "application/x-pkcs12",
  p7m: "application/pkcs7-mime",
  p7s: "application/pkcs7-signature",
  p7r: "application/x-pkcs7-certreqresp",
  p7b: "application/x-pkcs7-certificates",
  p8: "application/pkcs8",
  plf: "application/vnd.pocketlearn",
  pnm: "image/x-portable-anymap",
  pbm: "image/x-portable-bitmap",
  pcf: "application/x-font-pcf",
  pfr: "application/font-tdpfr",
  pgn: "application/x-chess-pgn",
  pgm: "image/x-portable-graymap",
  png: "image/png",
  ppm: "image/x-portable-pixmap",
  pskcxml: "application/pskc+xml",
  pml: "application/vnd.ctc-posml",
  ai: "application/postscript",
  pfa: "application/x-font-type1",
  pbd: "application/vnd.powerbuilder6",
  pgp: "application/pgp-signature",
  box: "application/vnd.previewsystems.box",
  ptid: "application/vnd.pvi.ptid1",
  pls: "application/pls+xml",
  str: "application/vnd.pg.format",
  ei6: "application/vnd.pg.osasli",
  dsc: "text/prs.lines.tag",
  psf: "application/x-font-linux-psf",
  qps: "application/vnd.publishare-delta-tree",
  wg: "application/vnd.pmi.widget",
  qxd: "application/vnd.quark.quarkxpress",
  esf: "application/vnd.epson.esf",
  msf: "application/vnd.epson.msf",
  ssf: "application/vnd.epson.ssf",
  qam: "application/vnd.epson.quickanime",
  qfx: "application/vnd.intu.qfx",
  qt: "video/quicktime",
  rar: "application/x-rar-compressed",
  ram: "audio/x-pn-realaudio",
  rmp: "audio/x-pn-realaudio-plugin",
  rsd: "application/rsd+xml",
  rm: "application/vnd.rn-realmedia",
  bed: "application/vnd.realvnc.bed",
  mxl: "application/vnd.recordare.musicxml",
  musicxml: "application/vnd.recordare.musicxml+xml",
  rnc: "application/relax-ng-compact-syntax",
  rdz: "application/vnd.data-vision.rdz",
  rdf: "application/rdf+xml",
  rp9: "application/vnd.cloanto.rp9",
  jisp: "application/vnd.jisp",
  rtf: "application/rtf",
  rtx: "text/richtext",
  link66: "application/vnd.route66.link66+xml",
  rss: "application/rss+xml",
  shf: "application/shf+xml",
  st: "application/vnd.sailingtracker.track",
  svg: "image/svg+xml",
  sus: "application/vnd.sus-calendar",
  sru: "application/sru+xml",
  setpay: "application/set-payment-initiation",
  setreg: "application/set-registration-initiation",
  sema: "application/vnd.sema",
  semd: "application/vnd.semd",
  semf: "application/vnd.semf",
  see: "application/vnd.seemail",
  snf: "application/x-font-snf",
  spq: "application/scvp-vp-request",
  spp: "application/scvp-vp-response",
  scq: "application/scvp-cv-request",
  scs: "application/scvp-cv-response",
  sdp: "application/sdp",
  etx: "text/x-setext",
  movie: "video/x-sgi-movie",
  ifm: "application/vnd.shana.informed.formdata",
  itp: "application/vnd.shana.informed.formtemplate",
  iif: "application/vnd.shana.informed.interchange",
  ipk: "application/vnd.shana.informed.package",
  tfi: "application/thraud+xml",
  shar: "application/x-shar",
  rgb: "image/x-rgb",
  slt: "application/vnd.epson.salt",
  aso: "application/vnd.accpac.simply.aso",
  imp: "application/vnd.accpac.simply.imp",
  twd: "application/vnd.simtech-mindmapper",
  csp: "application/vnd.commonspace",
  saf: "application/vnd.yamaha.smaf-audio",
  mmf: "application/vnd.smaf",
  spf: "application/vnd.yamaha.smaf-phrase",
  teacher: "application/vnd.smart.teacher",
  svd: "application/vnd.svd",
  rq: "application/sparql-query",
  srx: "application/sparql-results+xml",
  gram: "application/srgs",
  grxml: "application/srgs+xml",
  ssml: "application/ssml+xml",
  skp: "application/vnd.koan",
  sgml: "text/sgml",
  sdc: "application/vnd.stardivision.calc",
  sda: "application/vnd.stardivision.draw",
  sdd: "application/vnd.stardivision.impress",
  smf: "application/vnd.stardivision.math",
  sdw: "application/vnd.stardivision.writer",
  sgl: "application/vnd.stardivision.writer-global",
  sm: "application/vnd.stepmania.stepchart",
  sit: "application/x-stuffit",
  sitx: "application/x-stuffitx",
  sdkm: "application/vnd.solent.sdkm+xml",
  xo: "application/vnd.olpc-sugar",
  au: "audio/basic",
  wqd: "application/vnd.wqd",
  sis: "application/vnd.symbian.install",
  smi: "application/smil+xml",
  xsm: "application/vnd.syncml+xml",
  bdm: "application/vnd.syncml.dm+wbxml",
  xdm: "application/vnd.syncml.dm+xml",
  sv4cpio: "application/x-sv4cpio",
  sv4crc: "application/x-sv4crc",
  sbml: "application/sbml+xml",
  tsv: "text/tab-separated-values",
  tiff: "image/tiff",
  tao: "application/vnd.tao.intent-module-archive",
  tar: "application/x-tar",
  tcl: "application/x-tcl",
  tex: "application/x-tex",
  tfm: "application/x-tex-tfm",
  tei: "application/tei+xml",
  txt: "text/plain",
  dxp: "application/vnd.spotfire.dxp",
  sfs: "application/vnd.spotfire.sfs",
  tsd: "application/timestamped-data",
  tpt: "application/vnd.trid.tpt",
  mxs: "application/vnd.triscape.mxs",
  t: "text/troff",
  tra: "application/vnd.trueapp",
  ttf: "application/x-font-ttf",
  ttl: "text/turtle",
  umj: "application/vnd.umajin",
  uoml: "application/vnd.uoml+xml",
  unityweb: "application/vnd.unity",
  ufd: "application/vnd.ufdl",
  uri: "text/uri-list",
  utz: "application/vnd.uiq.theme",
  ustar: "application/x-ustar",
  uu: "text/x-uuencode",
  vcs: "text/x-vcalendar",
  vcf: "text/x-vcard",
  vcd: "application/x-cdlink",
  vsf: "application/vnd.vsf",
  wrl: "model/vrml",
  vcx: "application/vnd.vcx",
  mts: "model/vnd.mts",
  vtu: "model/vnd.vtu",
  vis: "application/vnd.visionary",
  viv: "video/vnd.vivo",
  ccxml: "application/ccxml+xml,",
  vxml: "application/voicexml+xml",
  src: "application/x-wais-source",
  wbxml: "application/vnd.wap.wbxml",
  wbmp: "image/vnd.wap.wbmp",
  wav: "audio/x-wav",
  davmount: "application/davmount+xml",
  woff: "application/x-font-woff",
  wspolicy: "application/wspolicy+xml",
  webp: "image/webp",
  wtb: "application/vnd.webturbo",
  wgt: "application/widget",
  hlp: "application/winhlp",
  wml: "text/vnd.wap.wml",
  wmls: "text/vnd.wap.wmlscript",
  wmlsc: "application/vnd.wap.wmlscriptc",
  wpd: "application/vnd.wordperfect",
  stf: "application/vnd.wt.stf",
  wsdl: "application/wsdl+xml",
  xbm: "image/x-xbitmap",
  xpm: "image/x-xpixmap",
  xwd: "image/x-xwindowdump",
  der: "application/x-x509-ca-cert",
  fig: "application/x-xfig",
  xhtml: "application/xhtml+xml",
  xml: "application/xml",
  xdf: "application/xcap-diff+xml",
  xenc: "application/xenc+xml",
  xer: "application/patch-ops-error+xml",
  rl: "application/resource-lists+xml",
  rs: "application/rls-services+xml",
  rld: "application/resource-lists-diff+xml",
  xslt: "application/xslt+xml",
  xop: "application/xop+xml",
  xpi: "application/x-xpinstall",
  xspf: "application/xspf+xml",
  xul: "application/vnd.mozilla.xul+xml",
  xyz: "chemical/x-xyz",
  yaml: "text/yaml",
  yang: "application/yang",
  yin: "application/yin+xml",
  zir: "application/vnd.zul",
  zip: "application/zip",
  zmm: "application/vnd.handheld-entertainment+xml",
  zaz: "application/vnd.zzazz.deck+xml"
};

// TODO: write this out to avoid compute
var MIME_TYPES_TO_EXT = Object.fromEntries(Object.entries(EXT_TO_MIME_TYPES).map(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
    k = _ref2[0],
    v = _ref2[1];
  return [v, k];
}));

var MIME_TYPE_REGEX = /^data:(.*?);base64,/;
function getMimeType(base64Url) {
  var match = MIME_TYPE_REGEX.exec(base64Url);
  if (match && match[1]) {
    return match[1];
  }
  return;
}
function mimeTypeToFileExt(mimeType) {
  var recognizedMimeType = MIME_TYPES_TO_EXT[mimeType];
  if (recognizedMimeType) {
    return recognizedMimeType;
  }
  return mimeType.split("/")[1];
}
function filenameToMimeType(filename) {
  var ext = filename.split(".").pop();
  var recognizedExt = ext && EXT_TO_MIME_TYPES[ext];
  if (recognizedExt) {
    return recognizedExt;
  }
}

function deserializeSchema(serialized) {
  var _serialized$options;
  switch (serialized.type) {
    case "string":
      return new StringSchema(_objectSpread2(_objectSpread2({}, serialized.options), {}, {
        regexp: ((_serialized$options = serialized.options) === null || _serialized$options === void 0 ? void 0 : _serialized$options.regexp) && new RegExp(serialized.options.regexp.source, serialized.options.regexp.flags)
      }), serialized.opt);
    case "literal":
      return new LiteralSchema(serialized.value, serialized.opt);
    case "boolean":
      return new BooleanSchema(serialized.opt);
    case "number":
      return new NumberSchema(serialized.options, serialized.opt);
    case "object":
      return new ObjectSchema(Object.fromEntries(Object.entries(serialized.items).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          item = _ref2[1];
        return [key, deserializeSchema(item)];
      })), serialized.opt);
    case "array":
      return new ArraySchema(deserializeSchema(serialized.item), serialized.opt);
    case "union":
      return new UnionSchema(typeof serialized.key === "string" ? serialized.key :
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      deserializeSchema(serialized.key),
      // TODO: we do not really need any here - right?
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      serialized.items.map(deserializeSchema),
      // TODO: we do not really need any here - right?
      serialized.opt);
    case "richtext":
      return new RichTextSchema(serialized.options || {}, serialized.opt);
    case "record":
      return new RecordSchema(deserializeSchema(serialized.item), serialized.opt);
    case "keyOf":
      return new KeyOfSchema(serialized.schema, serialized.path, serialized.opt);
    case "file":
      return new FileSchema(serialized.options, serialized.opt);
    case "image":
      return new ImageSchema(serialized.options, serialized.opt);
    case "date":
      return new DateSchema(serialized.options);
    default:
      {
        var exhaustiveCheck = serialized;
        var unknownSerialized = exhaustiveCheck;
        if (unknownSerialized && _typeof(unknownSerialized) === "object" && "type" in unknownSerialized) {
          throw new Error("Unknown schema type: ".concat(unknownSerialized.type));
        } else {
          throw new Error("Unknown schema: ".concat(JSON.stringify(unknownSerialized, null, 2)));
        }
      }
  }
}

var ModuleFilePathSep = "?p=";
var FATAL_ERROR_TYPES = ["no-schema", "no-source", "invalid-id", "no-module", "invalid-patch"];
var Internal = {
  VERSION: {
    core: function () {
      try {
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        return require("../package.json").version;
      } catch (_unused) {
        return null;
      }
    }()
  },
  convertFileSource: convertFileSource,
  getSchema: getSchema,
  getValPath: getValPath,
  getVal: getVal,
  getSource: getSource,
  resolvePath: resolvePath,
  splitModuleFilePathAndModulePath: splitModuleFilePathAndModulePath,
  joinModuleFilePathAndModulePath: joinModuleFilePathAndModulePath,
  isVal: isVal,
  createValPathOfItem: createValPathOfItem,
  getSHA256Hash: getSHA256Hash,
  initSchema: initSchema,
  getMimeType: getMimeType,
  mimeTypeToFileExt: mimeTypeToFileExt,
  filenameToMimeType: filenameToMimeType,
  EXT_TO_MIME_TYPES: EXT_TO_MIME_TYPES,
  MIME_TYPES_TO_EXT: MIME_TYPES_TO_EXT,
  ModuleFilePathSep: ModuleFilePathSep,
  notFileOp: function notFileOp(op) {
    return op.op !== "file";
  },
  isFileOp: function isFileOp(op) {
    return op.op === "file" && typeof op.filePath === "string";
  },
  createPatchJSONPath: function createPatchJSONPath(modulePath) {
    return "/".concat(modulePath.split(".").map(function (segment) {
      return segment && tryJsonParse(segment);
    }).join("/"));
  },
  createPatchPath: function createPatchPath(modulePath) {
    return splitModulePath(modulePath);
  },
  splitModulePath: splitModulePath,
  splitModuleFilePath: splitModuleFilePath,
  splitJoinedSourcePaths: splitJoinedSourcePaths,
  parentOfSourcePath: parentOfSourcePath,
  patchPathToModulePath: patchPathToModulePath,
  VAL_ENABLE_COOKIE_NAME: "val_enable",
  VAL_STATE_COOKIE: "val_state",
  VAL_SESSION_COOKIE: "val_session",
  createFilename: function createFilename(data, filename, metadata, sha256) {
    var _Internal$getMimeType, _Internal$mimeTypeToF;
    if (!metadata) {
      return filename;
    }
    if (!data) {
      return filename;
    }
    var shaSuffix = sha256.slice(0, 5);
    var mimeType = (_Internal$getMimeType = Internal.getMimeType(data)) !== null && _Internal$getMimeType !== void 0 ? _Internal$getMimeType : "unknown";
    var newExt = (_Internal$mimeTypeToF = Internal.mimeTypeToFileExt(mimeType)) !== null && _Internal$mimeTypeToF !== void 0 ? _Internal$mimeTypeToF : "unknown"; // Don't trust the file extension
    if (filename) {
      var cleanFilename = filename.split(".").slice(0, -1).join(".") || filename; // remove extension if it exists
      var maybeShaSuffixPos = cleanFilename.lastIndexOf("_");
      var currentShaSuffix = cleanFilename.slice(maybeShaSuffixPos + 1, cleanFilename.length);
      if (currentShaSuffix === shaSuffix) {
        cleanFilename = cleanFilename.slice(0, maybeShaSuffixPos);
      }
      var escapedFilename = encodeURIComponent(cleanFilename).replace(/%[0-9A-Fa-f]{2}/g, "").toLowerCase();
      return "".concat(escapedFilename, "_").concat(shaSuffix, ".").concat(newExt);
    }
    return "".concat(sha256, ".").concat(newExt);
  }
};
function tryJsonParse(str) {
  try {
    return JSON.parse(str);
  } catch (err) {
    return str;
  }
}

export { ArraySchema as A, BooleanSchema as B, Call as C, DateSchema as D, Expr as E, FATAL_ERROR_TYPES as F, GenericSelector as G, Internal as I, KeyOfSchema as K, LiteralSchema as L, ModuleFilePathSep as M, NilSym as N, ObjectSchema as O, PatchError as P, RecordSchema as R, StringLiteral as S, UnionSchema as U, VAL_EXTENSION as V, _typeof as _, _slicedToArray as a, _createClass as b, _classCallCheck as c, _toConsumableArray as d, StringTemplate as e, Sym as f, evaluate as g, initVal as h, index as i, Schema as j, FILE_REF_PROP as k, FILE_REF_SUBTYPE_TAG as l, modules as m, derefPatch as n, StringSchema as o, parse as p, NumberSchema as q, ImageSchema as r, splitModuleFilePathAndModulePath as s, FileSchema as t, RichTextSchema as u, deserializeSchema as v };
